const planColorMap = {
    "(NULL)": {
        label: "(NULL)",
        color: "#808080",
        gradient: "linear-gradient(45deg, #808080, #A9A9A9)",
    },
    "OPEN PRIVATE FOR EMPLOYEES": {
        label: "Open Private for Employees",
        color: "#4682B4",
        gradient: "linear-gradient(45deg, #4682B4, #87CEEB)",
    },
    "OPEN PRIVATE FOR DEPENDENTS": {
        label: "Open Private for Dependents",
        color: "#6A5ACD",
        gradient: "linear-gradient(45deg, #6A5ACD, #B0C4DE)",
    },
    "EXECUTIVE PRIVATE": {
        label: "Executive Private",
        color: "#2F4F4F",
        gradient: "linear-gradient(45deg, #2F4F4F, #708090)",
    },
    "OPEN PRIVATE FOR DEP. SPOUSE": {
        label: "Open Private for Dep. Spouse",
        color: "#6A5ACD",
        gradient: "linear-gradient(45deg, #6A5ACD, #B0C4DE)",
    },
    Gold: {
        label: "Gold",
        color: "#FFD700",
        // gradient: "linear-gradient(45deg, #FFD700, #FFA500)",
        gradient: "linear-gradient(45deg, #FFD700, #e29300ff)",
    },
    Bronze: {
        label: "Bronze",
        color: "#CD7F32",
        gradient: "linear-gradient(45deg, #CD7F32, #8C5523)",
    },
    "PLAN ALSCOPHIL": {
        label: "Plan Alscophil",
        color: "#228B22",
        gradient: "linear-gradient(45deg, #228B22, #66CDAA)",
    },
    "Plan - MBL": {
        label: "Plan - MBL",
        color: "#20B2AA",
        gradient: "linear-gradient(45deg, #20B2AA, #66CDAA)",
    },
    "Plan - ABL": {
        label: "Plan - ABL",
        color: "#3CB371",
        gradient: "linear-gradient(45deg, #3CB371, #90EE90)",
    },
    Private: {
        label: "Private",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "Private Dependent": {
        label: "Private Dependent",
        color: "#483D8B",
        gradient: "linear-gradient(45deg, #483D8B, #B0C4DE)",
    },
    "PLAN ABL": {
        label: "Plan ABL",
        color: "#3CB371",
        gradient: "linear-gradient(45deg, #3CB371, #90EE90)",
    },
    "PLAN ABL ABL": {
        label: "Plan ABL ABL",
        color: "#2E8B57",
        gradient: "linear-gradient(45deg, #2E8B57, #98FB98)",
    },
    "Plan MBL for Principal": {
        label: "Plan MBL for Principal",
        color: "#20B2AA",
        gradient: "linear-gradient(45deg, #20B2AA, #66CDAA)",
    },
    "Plan ABL for Dependent - Test": {
        label: "Plan ABL for Dependent - Test",
        color: "#FF4500",
        gradient: "linear-gradient(45deg, #FF4500, #FFA07A)",
    },
    "Plan for Principal": {
        label: "Plan for Principal",
        color: "#1E90FF",
        gradient: "linear-gradient(45deg, #1E90FF, #87CEEB)",
    },
    "Plan for Dependent": {
        label: "Plan for Dependent",
        color: "#FFA500",
        gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)",
    },
    "Kathleen MBL as charged Test": {
        label: "Kathleen MBL as charged Test",
        color: "#FF69B4",
        gradient: "linear-gradient(45deg, #FF69B4, #FFB6C1)",
    },
    "Kathleen ABL as charged Test": {
        label: "Kathleen ABL as charged Test",
        color: "#FF4500",
        gradient: "linear-gradient(45deg, #FF4500, #FFA07A)",
    },
    "TEST BASIC BENEFIT - ABL": {
        label: "Test Basic Benefit - ABL",
        color: "#FF4500",
        gradient: "linear-gradient(45deg, #FF4500, #FFA07A)",
    },
    "TEST BASIC BENEFIT - MBL": {
        label: "Test Basic Benefit - MBL",
        color: "#FF69B4",
        gradient: "linear-gradient(45deg, #FF69B4, #FFB6C1)",
    },
    "TEST B & M - MBL": {
        label: "Test B & M - MBL",
        color: "#FF69B4",
        gradient: "linear-gradient(45deg, #FF69B4, #FFB6C1)",
    },
    "TEST B & M - ABL": {
        label: "Test B & M - ABL",
        color: "#FF4500",
        gradient: "linear-gradient(45deg, #FF4500, #FFA07A)",
    },
    Executive: {
        label: "Executive",
        color: "#2F4F4F",
        gradient: "linear-gradient(45deg, #2F4F4F, #708090)",
    },
    Silver: {
        label: "Silver",
        color: "#C0C0C0",
        gradient: "linear-gradient(45deg, #C0C0C0, #A9A9A9)",
    },
    "QA Testing Plan (MBL)": {
        label: "QA Testing Plan (MBL)",
        color: "#FF69B4",
        gradient: "linear-gradient(45deg, #FF69B4, #FFB6C1)",
    },
    "QA Testing Plan (ABL)": {
        label: "QA Testing Plan (ABL)",
        color: "#FF4500",
        gradient: "linear-gradient(45deg, #FF4500, #FFA07A)",
    },
    Regular: {
        label: "Regular",
        color: "#808080",
        gradient: "linear-gradient(45deg, #808080, #A9A9A9)",
    },
    "TEST ABL NO REIM": {
        label: "Test ABL No Reim",
        color: "#FF4500",
        gradient: "linear-gradient(45deg, #FF4500, #FFA07A)",
    },
    "TEST ABL": {
        label: "Test ABL",
        color: "#FF4500",
        gradient: "linear-gradient(45deg, #FF4500, #FFA07A)",
    },
    "TEST ABL & MBL": {
        label: "Test ABL & MBL",
        color: "#C71585",
        gradient: "linear-gradient(45deg, #C71585, #FF69B4)",
    },
    "TEST MBL": {
        label: "Test MBL",
        color: "#FF69B4",
        gradient: "linear-gradient(45deg, #FF69B4, #FFB6C1)",
    },
    "QA Plan MBL - 2": {
        label: "QA Plan MBL - 2",
        color: "#FF69B4",
        gradient: "linear-gradient(45deg, #FF69B4, #FFB6C1)",
    },
    "QA Plan ABL - 2": {
        label: "QA Plan ABL - 2",
        color: "#FF4500",
        gradient: "linear-gradient(45deg, #FF4500, #FFA07A)",
    },
    Rigel_Dependent: {
        label: "Rigel Dependent",
        color: "#FFA500",
        gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)",
    },
    "Individual Silver - Private": {
        label: "Individual Silver - Private",
        color: "#C0C0C0",
        gradient: "linear-gradient(45deg, #C0C0C0, #A9A9A9)",
    },
    "Individual Gold - Semi - Private": {
        label: "Individual Gold - Semi - Private",
        color: "#FFD700",
        gradient: "linear-gradient(45deg, #FFD700, #FFA500)",
    },
    "Individual Silver - Semi Private": {
        label: "Individual Silver - Semi Private",
        color: "#C0C0C0",
        gradient: "linear-gradient(45deg, #C0C0C0, #A9A9A9)",
    },
    "Individual Gold - Private": {
        label: "Individual Gold - Private",
        color: "#FFD700",
        gradient: "linear-gradient(45deg, #FFD700, #FFA500)",
    },
    "Family Principal - Private": {
        label: "Family Principal - Private",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "Family Dependent - Private": {
        label: "Family Dependent - Private",
        color: "#483D8B",
        gradient: "linear-gradient(45deg, #483D8B, #B0C4DE)",
    },
    "Individual Bronze - Semi Private": {
        label: "Individual Bronze - Semi Private",
        color: "#CD7F32",
        gradient: "linear-gradient(45deg, #CD7F32, #8C5523)",
    },
    "GTS Plan 1": {
        label: "GTS Plan 1",
        color: "#228B22",
        gradient: "linear-gradient(45deg, #228B22, #66CDAA)",
    },
    "GTS Plan 2": {
        label: "GTS Plan 2",
        color: "#2E8B57",
        gradient: "linear-gradient(45deg, #2E8B57, #98FB98)",
    },
    "GTS Plan 3": {
        label: "GTS Plan 3",
        color: "#3CB371",
        gradient: "linear-gradient(45deg, #3CB371, #90EE90)",
    },
    "Test exec": {
        label: "Test Exec",
        color: "#FF4500",
        gradient: "linear-gradient(45deg, #FF4500, #FFA07A)",
    },
    Manager: {
        label: "Manager",
        color: "#008080",
        gradient: "linear-gradient(45deg, #008080, #20B2AA)",
    },
    Officer: {
        label: "Officer",
        color: "#4682B4",
        gradient: "linear-gradient(45deg, #4682B4, #87CEEB)",
    },
    "Principal Plan": {
        label: "Principal Plan",
        color: "#1E90FF",
        gradient: "linear-gradient(45deg, #1E90FF, #87CEEB)",
    },
    "Dependent Plan": {
        label: "Dependent Plan",
        color: "#FFA500",
        gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)",
    },
    "Premium for Principals": {
        label: "Premium for Principals",
        color: "#1E90FF",
        gradient: "linear-gradient(45deg, #1E90FF, #87CEEB)",
    },
    "MIESCOR_PLAN 1": {
        label: "Miescor Plan 1",
        color: "#228B22",
        gradient: "linear-gradient(45deg, #228B22, #66CDAA)",
    },
    "MAGSAYSAY_PLAN 1": {
        label: "Magsaysay Plan 1",
        color: "#2E8B57",
        gradient: "linear-gradient(45deg, #2E8B57, #98FB98)",
    },
    "OPTION 1": {
        label: "Option 1",
        color: "#808080",
        gradient: "linear-gradient(45deg, #808080, #A9A9A9)",
    },
    "OPTION 2": {
        label: "Option 2",
        color: "#696969",
        gradient: "linear-gradient(45deg, #696969, #A9A9A9)",
    },
    "OPTION 3": {
        label: "Option 3",
        color: "#A9A9A9",
        gradient: "linear-gradient(45deg, #A9A9A9, #C0C0C0)",
    },
    "FAMILY PRINCIPAL - SEMI-PRIVATE": {
        label: "Family Principal - Semi-Private",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    "FAMILY DEPENDENT - SEMI-PRIVATE": {
        label: "Family Dependent - Semi-Private",
        color: "#228B22",
        gradient: "linear-gradient(45deg, #228B22, #66CDAA)",
    },
    "CORPORATE GOLD PRINCIPAL- PRIVATE": {
        label: "Corporate Gold Principal - Private",
        color: "#FFD700",
        gradient: "linear-gradient(45deg, #FFD700, #FFA500)",
    },
    "CORPORATE GOLD DEPENDENT- PRIVATE": {
        label: "Corporate Gold Dependent - Private",
        color: "#FFD700",
        gradient: "linear-gradient(45deg, #FFD700, #FFA500)",
    },
    "CORPORATE SILVER PRINCIPAL- PRIVATE": {
        label: "Corporate Silver Principal - Private",
        color: "#C0C0C0",
        gradient: "linear-gradient(45deg, #C0C0C0, #A9A9A9)",
    },
    "CORPORATE SILVER DEPENDENT- PRIVATE": {
        label: "Corporate Silver Dependent - Private",
        color: "#C0C0C0",
        gradient: "linear-gradient(45deg, #C0C0C0, #A9A9A9)",
    },
    "CORPORATE GOLD PRINCIPAL- SEMI-PRIVATE": {
        label: "Corporate Gold Principal - Semi-Private",
        color: "#FFD700",
        gradient: "linear-gradient(45deg, #FFD700, #FFA500)",
    },
    "CORPORATE SILVER PRINCIPAL- SEMI-PRIVATE": {
        label: "Corporate Silver Principal - Semi-Private",
        color: "#C0C0C0",
        gradient: "linear-gradient(45deg, #C0C0C0, #A9A9A9)",
    },
    "CORPORATE BRONZE DEPENDENT- WARD": {
        label: "Corporate Bronze Dependent - Ward",
        color: "#CD7F32",
        gradient: "linear-gradient(45deg, #CD7F32, #8C5523)",
    },
    "INDIVIDUAL GOLD - WARD": {
        label: "Individual Gold - Ward",
        color: "#FFD700",
        gradient: "linear-gradient(45deg, #FFD700, #FFA500)",
    },
    "OFFICERS & DEPENDENTS": {
        label: "Officers & Dependents",
        color: "#4682B4",
        gradient: "linear-gradient(45deg, #4682B4, #87CEEB)",
    },
    "ADMIN STAFF & DEPENDENTS": {
        label: "Admin Staff & Dependents",
        color: "#008080",
        gradient: "linear-gradient(45deg, #008080, #20B2AA)",
    },
    PRINCIPAL: {
        label: "Principal",
        color: "#1E90FF",
        gradient: "linear-gradient(45deg, #1E90FF, #87CEEB)",
    },
    DEPENDENT: {
        label: "Dependent",
        color: "#FFA500",
        gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)",
    },
    "PLAN 1": {
        label: "Plan 1",
        color: "#808080",
        gradient: "linear-gradient(45deg, #808080, #A9A9A9)",
    },
    "PLAN 2": {
        label: "Plan 2",
        color: "#696969",
        gradient: "linear-gradient(45deg, #696969, #A9A9A9)",
    },
    "PLAN 3": {
        label: "Plan 3",
        color: "#A9A9A9",
        gradient: "linear-gradient(45deg, #A9A9A9, #C0C0C0)",
    },
    "PLAN 4": {
        label: "Plan 4",
        color: "#708090",
        gradient: "linear-gradient(45deg, #708090, #B0C4DE)",
    },
    "INDIVIDUAL SILVER - WARD": {
        label: "Individual Silver - Ward",
        color: "#C0C0C0",
        gradient: "linear-gradient(45deg, #C0C0C0, #A9A9A9)",
    },
    "INDIVIDUAL BRONZE- PRIVATE": {
        label: "Individual Bronze - Private",
        color: "#CD7F32",
        gradient: "linear-gradient(45deg, #CD7F32, #8C5523)",
    },
    "OPTION 5": {
        label: "Option 5",
        color: "#B0C4DE",
        gradient: "linear-gradient(45deg, #B0C4DE, #D3D3D3)",
    },
    "Rank & File": {
        label: "Rank & File",
        color: "#228B22",
        gradient: "linear-gradient(45deg, #228B22, #66CDAA)",
    },
    "Rank & File 2": {
        label: "Rank & File 2",
        color: "#2E8B57",
        gradient: "linear-gradient(45deg, #2E8B57, #98FB98)",
    },
    "PCF/SALES": {
        label: "PCF/Sales",
        color: "#008080",
        gradient: "linear-gradient(45deg, #008080, #20B2AA)",
    },
    Supervisor: {
        label: "Supervisor",
        color: "#008080",
        gradient: "linear-gradient(45deg, #008080, #20B2AA)",
    },
    "Division Manager": {
        label: "Division Manager",
        color: "#2F4F4F",
        gradient: "linear-gradient(45deg, #2F4F4F, #708090)",
    },
    PCF: {
        label: "PCF",
        color: "#008080",
        gradient: "linear-gradient(45deg, #008080, #20B2AA)",
    },
    "R&F": {
        label: "R&F",
        color: "#228B22",
        gradient: "linear-gradient(45deg, #228B22, #66CDAA)",
    },
    "PLAN I": {
        label: "Plan I",
        color: "#808080",
        gradient: "linear-gradient(45deg, #808080, #A9A9A9)",
    },
    "Plan Test 1001": {
        label: "Plan Test 1001",
        color: "#FF4500",
        gradient: "linear-gradient(45deg, #FF4500, #FFA07A)",
    },
    "PLAN A": {
        label: "Plan A",
        color: "#808080",
        gradient: "linear-gradient(45deg, #808080, #A9A9A9)",
    },
    "PLAN B": {
        label: "Plan B",
        color: "#696969",
        gradient: "linear-gradient(45deg, #696969, #A9A9A9)",
    },
    "PLAN C": {
        label: "Plan C",
        color: "#A9A9A9",
        gradient: "linear-gradient(45deg, #A9A9A9, #C0C0C0)",
    },
    "PLAN D": {
        label: "Plan D",
        color: "#708090",
        gradient: "linear-gradient(45deg, #708090, #B0C4DE)",
    },
    "PLAN E": {
        label: "Plan E",
        color: "#B0C4DE",
        gradient: "linear-gradient(45deg, #B0C4DE, #D3D3D3)",
    },
    "PLAN F": {
        label: "Plan F",
        color: "#4682B4",
        gradient: "linear-gradient(45deg, #4682B4, #87CEEB)",
    },
    1: {
        label: "1",
        color: "#808080",
        gradient: "linear-gradient(45deg, #808080, #A9A9A9)",
    },
    2: {
        label: "2",
        color: "#696969",
        gradient: "linear-gradient(45deg, #696969, #A9A9A9)",
    },
    3: {
        label: "3",
        color: "#A9A9A9",
        gradient: "linear-gradient(45deg, #A9A9A9, #C0C0C0)",
    },
    "INDIVIDUAL (2) - PRIVATE": {
        label: "Individual (2) - Private",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "CLASS 1": {
        label: "Class 1",
        color: "#808080",
        gradient: "linear-gradient(45deg, #808080, #A9A9A9)",
    },
    "CLASS 2": {
        label: "Class 2",
        color: "#696969",
        gradient: "linear-gradient(45deg, #696969, #A9A9A9)",
    },
    "CLASS 3": {
        label: "Class 3",
        color: "#A9A9A9",
        gradient: "linear-gradient(45deg, #A9A9A9, #C0C0C0)",
    },
    "FAMILY PRINCIPAL - PRIVATE (2)": {
        label: "Family Principal - Private (2)",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "FAMILY DEPENDENT - PRIVATE (2)": {
        label: "Family Dependent - Private (2)",
        color: "#483D8B",
        gradient: "linear-gradient(45deg, #483D8B, #B0C4DE)",
    },
    "CLASS 4 (DEPT)": {
        label: "Class 4 (Dept)",
        color: "#708090",
        gradient: "linear-gradient(45deg, #708090, #B0C4DE)",
    },
    "INDIVIDUAL SILVER (2) - SEMI PRIVATE": {
        label: "Individual Silver (2) - Semi Private",
        color: "#C0C0C0",
        gradient: "linear-gradient(45deg, #C0C0C0, #A9A9A9)",
    },
    "INDIVIDUAL (3) - PRIVATE": {
        label: "Individual (3) - Private",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "Rigel Dependent Plan": {
        label: "Rigel Dependent Plan",
        color: "#FFA500",
        gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)",
    },
    "OPEN PRIVATE - 150,000 (PRINCIPAL)": {
        label: "Open Private - 150,000 (Principal)",
        color: "#4682B4",
        gradient: "linear-gradient(45deg, #4682B4, #87CEEB)",
    },
    "REGULAR PRIVATE - 100,000 (PRINCIPAL)": {
        label: "Regular Private - 100,000 (Principal)",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "REGULAR PRIVATE - 75,000 (PRINCIPAL)": {
        label: "Regular Private - 75,000 (Principal)",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "SEMI-PRIVATE - 75,000 (PRINCIPAL)": {
        label: "Semi-Private - 75,000 (Principal)",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    "CLASS 4": {
        label: "Class 4",
        color: "#708090",
        gradient: "linear-gradient(45deg, #708090, #B0C4DE)",
    },
    "WARD - 50,000 (DEPENDENT)": {
        label: "Ward - 50,000 (Dependent)",
        color: "#228B22",
        gradient: "linear-gradient(45deg, #228B22, #66CDAA)",
    },
    "CORPORATE GOLD PRINCIPAL- REGULAR PRIVATE": {
        label: "Corporate Gold Principal - Regular Private",
        color: "#FFD700",
        gradient: "linear-gradient(45deg, #FFD700, #FFA500)",
    },
    "CORPORATE GOLD PRINCIPAL- WARD": {
        label: "Corporate Gold Principal - Ward",
        color: "#FFD700",
        gradient: "linear-gradient(45deg, #FFD700, #FFA500)",
    },
    "Plan - both": {
        label: "Plan - Both",
        color: "#800080",
        gradient: "linear-gradient(45deg, #800080, #C71585)",
    },
    "OPEN PRIVATE - 110,000 (PRINCIPAL)": {
        label: "Open Private - 110,000 (Principal)",
        color: "#4682B4",
        gradient: "linear-gradient(45deg, #4682B4, #87CEEB)",
    },
    "OPEN PRIVATE - 110,000 (DEPENDENTS)": {
        label: "Open Private - 110,000 (Dependents)",
        color: "#6A5ACD",
        gradient: "linear-gradient(45deg, #6A5ACD, #B0C4DE)",
    },
    "SEMI-PRIVATE - 95,000 (PRINCIPAL)": {
        label: "Semi-Private - 95,000 (Principal)",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    "SEMI-PRIVATE -95,000 (DEPENDENTS)": {
        label: "Semi-Private - 95,000 (Dependents)",
        color: "#228B22",
        gradient: "linear-gradient(45deg, #228B22, #66CDAA)",
    },
    PLATINUM: {
        label: "Platinum",
        color: "#E5E4E2",
        gradient: "linear-gradient(45deg, #E5E4E2, #B0B0B0)",
    },
    "REGULAR PRIVATE - 50,000 (PRINCIPAL)": {
        label: "Regular Private - 50,000 (Principal)",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "SEMI-PRIVATE - 37,500 (PRINCIPAL)": {
        label: "Semi-Private - 37,500 (Principal)",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    "Plan 1-A": {
        label: "Plan 1-A",
        color: "#808080",
        gradient: "linear-gradient(45deg, #808080, #A9A9A9)",
    },
    "Plan 1-B": {
        label: "Plan 1-B",
        color: "#696969",
        gradient: "linear-gradient(45deg, #696969, #A9A9A9)",
    },
    "Plan 1-C": {
        label: "Plan 1-C",
        color: "#A9A9A9",
        gradient: "linear-gradient(45deg, #A9A9A9, #C0C0C0)",
    },
    "Plan 2": {
        label: "Plan 2",
        color: "#696969",
        gradient: "linear-gradient(45deg, #696969, #A9A9A9)",
    },
    "Plan 3": {
        label: "Plan 3",
        color: "#A9A9A9",
        gradient: "linear-gradient(45deg, #A9A9A9, #C0C0C0)",
    },
    "PLAN NEW": {
        label: "Plan New",
        color: "#808080",
        gradient: "linear-gradient(45deg, #808080, #A9A9A9)",
    },
    "OPEN PRIVATE - 120,000 (PRINCIPAL)": {
        label: "Open Private - 120,000 (Principal)",
        color: "#4682B4",
        gradient: "linear-gradient(45deg, #4682B4, #87CEEB)",
    },
    "WARD - 60,000 (PRINCIPAL)": {
        label: "Ward - 60,000 (Principal)",
        color: "#228B22",
        gradient: "linear-gradient(45deg, #228B22, #66CDAA)",
    },
    "REGULAR PRIVATE - 100,000 (DEPENDENT)": {
        label: "Regular Private - 100,000 (Dependent)",
        color: "#483D8B",
        gradient: "linear-gradient(45deg, #483D8B, #B0C4DE)",
    },
    "Joji plan": {
        label: "Joji Plan",
        color: "#FF4500",
        gradient: "linear-gradient(45deg, #FF4500, #FFA07A)",
    },
    "PRIVATE - 100,000 (PRINCIPAL)": {
        label: "Private - 100,000 (Principal)",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "SEMI- PRIVATE - 75,000 (PRINCIPAL)": {
        label: "Semi-Private - 75,000 (Principal)",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    "WARD - 50,000 (PRINCIPAL)": {
        label: "Ward - 50,000 (Principal)",
        color: "#228B22",
        gradient: "linear-gradient(45deg, #228B22, #66CDAA)",
    },
    "SEMI- PRIVATE - 75,000 (DEPENDENT)": {
        label: "Semi-Private - 75,000 (Dependent)",
        color: "#228B22",
        gradient: "linear-gradient(45deg, #228B22, #66CDAA)",
    },
    SUPERVISOR: {
        label: "Supervisor",
        color: "#008080",
        gradient: "linear-gradient(45deg, #008080, #20B2AA)",
    },
    MANAGER: {
        label: "Manager",
        color: "#008080",
        gradient: "linear-gradient(45deg, #008080, #20B2AA)",
    },
    "ASST. VICE PRESIDENT": {
        label: "Asst. Vice President",
        color: "#2F4F4F",
        gradient: "linear-gradient(45deg, #2F4F4F, #708090)",
    },
    "SENIOR AVP": {
        label: "Senior AVP",
        color: "#2F4F4F",
        gradient: "linear-gradient(45deg, #2F4F4F, #708090)",
    },
    "VICE PRESIDENT /SVP/PRES": {
        label: "Vice President/SVP/Pres",
        color: "#2F4F4F",
        gradient: "linear-gradient(45deg, #2F4F4F, #708090)",
    },
    "CORPORATE GOLD DEPENDENT- SEMI-PRIVATE": {
        label: "Corporate Gold Dependent - Semi-Private",
        color: "#FFD700",
        gradient: "linear-gradient(45deg, #FFD700, #FFA500)",
    },
    "CLASS 5": {
        label: "Class 5",
        color: "#4682B4",
        gradient: "linear-gradient(45deg, #4682B4, #87CEEB)",
    },
    "CLASS 6": {
        label: "Class 6",
        color: "#6A5ACD",
        gradient: "linear-gradient(45deg, #6A5ACD, #B0C4DE)",
    },
    "CLASS 7": {
        label: "Class 7",
        color: "#483D8B",
        gradient: "linear-gradient(45deg, #483D8B, #B0C4DE)",
    },
    "CLASS 8": {
        label: "Class 8",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "CLASS 9": {
        label: "Class 9",
        color: "#1E90FF",
        gradient: "linear-gradient(45deg, #1E90FF, #87CEEB)",
    },
    Staff: {
        label: "Staff",
        color: "#228B22",
        gradient: "linear-gradient(45deg, #228B22, #66CDAA)",
    },
    "SEMI- PRIVATE - 80,000 (PRINCIPAL)": {
        label: "Semi-Private - 80,000 (Principal)",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    "MBL IP (Special Case)": {
        label: "MBL IP (Special Case)",
        color: "#FF69B4",
        gradient: "linear-gradient(45deg, #FF69B4, #FFB6C1)",
    },
    "SEMI- PRIVATE - 100,000": {
        label: "Semi-Private - 100,000",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    "Individual - Open Private": {
        label: "Individual - Open Private",
        color: "#4682B4",
        gradient: "linear-gradient(45deg, #4682B4, #87CEEB)",
    },
    "PLATINUM-W/ MATERNITY PLAN": {
        label: "Platinum w/ Maternity Plan",
        color: "#E5E4E2",
        gradient: "linear-gradient(45deg, #E5E4E2, #B0B0B0)",
    },
    "REGULAR PRIVATE - 100,000": {
        label: "Regular Private - 100,000",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "Plan - 8,000": {
        label: "Plan - 8,000",
        color: "#808080",
        gradient: "linear-gradient(45deg, #808080, #A9A9A9)",
    },
    "PLAN - 6250.00": {
        label: "Plan - 6250.00",
        color: "#696969",
        gradient: "linear-gradient(45deg, #696969, #A9A9A9)",
    },
    "PLAN - 8,333.33": {
        label: "Plan - 8,333.33",
        color: "#A9A9A9",
        gradient: "linear-gradient(45deg, #A9A9A9, #C0C0C0)",
    },
    "PLAN - 12,083.33": {
        label: "Plan - 12,083.33",
        color: "#708090",
        gradient: "linear-gradient(45deg, #708090, #B0C4DE)",
    },
    "PLAN - 10,000.00": {
        label: "Plan - 10,000.00",
        color: "#4682B4",
        gradient: "linear-gradient(45deg, #4682B4, #87CEEB)",
    },
    "INDIVIDUAL-REGULAR PRIVATE": {
        label: "Individual - Regular Private",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "LARGE PRIVATE-200,000": {
        label: "Large Private - 200,000",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "REGULAR PRIVATE-100,000": {
        label: "Regular Private - 100,000",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "SEMI-PRIVATE-80,000": {
        label: "Semi-Private - 80,000",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    "WARD-70,000": {
        label: "Ward - 70,000",
        color: "#228B22",
        gradient: "linear-gradient(45deg, #228B22, #66CDAA)",
    },
    "LARGE PRIVATE (2) - 200,000": {
        label: "Large Private (2) - 200,000",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "REGULAR PRIVATE (2) - 100,000": {
        label: "Regular Private (2) - 100,000",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "SEMI-PRIVATE (2) - 80,000": {
        label: "Semi-Private (2) - 80,000",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    "WARD (2) - 70,000": {
        label: "Ward (2) - 70,000",
        color: "#228B22",
        gradient: "linear-gradient(45deg, #228B22, #66CDAA)",
    },
    "SEMI-PRIVATE - 75,000": {
        label: "Semi-Private - 75,000",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    "PLAN-10,000.00": {
        label: "Plan - 10,000.00",
        color: "#4682B4",
        gradient: "linear-gradient(45deg, #4682B4, #87CEEB)",
    },
    "DEPENDENT FAMILY SHARED PLAN": {
        label: "Dependent Family Shared Plan",
        color: "#FFA500",
        gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)",
    },
    "CREW MEMBERS COVERAGE (EXCLUSIVE TO CREW MEMBERS)": {
        label: "Crew Members Coverage",
        color: "#008080",
        gradient: "linear-gradient(45deg, #008080, #20B2AA)",
    },
    "SEMI-PRIVATE-150,000": {
        label: "Semi-Private - 150,000",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    "CORPORATE GOLD PRINCIPAL- OPEN PRIVATE": {
        label: "Corporate Gold Principal - Open Private",
        color: "#FFD700",
        gradient: "linear-gradient(45deg, #FFD700, #FFA500)",
    },
    "CORPORATE SILVER PRINCIPAL- SEMI-PRIVATE": {
        label: "Corporate Silver Principal - Semi-Private",
        color: "#C0C0C0",
        gradient: "linear-gradient(45deg, #C0C0C0, #A9A9A9)",
    },
    "LARGE PRIVATE - 200,000": {
        label: "Large Private - 200,000",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "REGULAR PRIVATE - 120,000": {
        label: "Regular Private - 120,000",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "REGULAR PRIVATE - 110,000": {
        label: "Regular Private - 110,000",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "SEMI-PRIVATE - 90,000": {
        label: "Semi-Private - 90,000",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    "Managers/Supervisors": {
        label: "Managers/Supervisors",
        color: "#008080",
        gradient: "linear-gradient(45deg, #008080, #20B2AA)",
    },
    Executives: {
        label: "Executives",
        color: "#2F4F4F",
        gradient: "linear-gradient(45deg, #2F4F4F, #708090)",
    },
    "PLAN 2 (CREW, OFFICERS)": {
        label: "Plan 2 (Crew, Officers)",
        color: "#008080",
        gradient: "linear-gradient(45deg, #008080, #20B2AA)",
    },
    "PLAN 1 (crew, ratings)": {
        label: "Plan 1 (Crew, Ratings)",
        color: "#228B22",
        gradient: "linear-gradient(45deg, #228B22, #66CDAA)",
    },
    "PLAN 4 (LANDBASED, MANAGEMENT)": {
        label: "Plan 4 (Landbased, Management)",
        color: "#2F4F4F",
        gradient: "linear-gradient(45deg, #2F4F4F, #708090)",
    },
    "Manager 1": {
        label: "Manager 1",
        color: "#008080",
        gradient: "linear-gradient(45deg, #008080, #20B2AA)",
    },
    "Manager 2": {
        label: "Manager 2",
        color: "#008080",
        gradient: "linear-gradient(45deg, #008080, #20B2AA)",
    },
    "Manager 3": {
        label: "Manager 3",
        color: "#008080",
        gradient: "linear-gradient(45deg, #008080, #20B2AA)",
    },
    "Rank & File 1": {
        label: "Rank & File 1",
        color: "#228B22",
        gradient: "linear-gradient(45deg, #228B22, #66CDAA)",
    },
    "Dependent 1": {
        label: "Dependent 1",
        color: "#FFA500",
        gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)",
    },
    "Dependent 2": {
        label: "Dependent 2",
        color: "#FFA500",
        gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)",
    },
    "INDIVIDUAL (4) - SEMI PRIVATE": {
        label: "Individual (4) - Semi Private",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    "OPEN PRIVATE-120,000": {
        label: "Open Private - 120,000",
        color: "#4682B4",
        gradient: "linear-gradient(45deg, #4682B4, #87CEEB)",
    },
    "SEMI-PRIVATE-90,000": {
        label: "Semi-Private - 90,000",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    "PLAN 4,000": {
        label: "Plan 4,000",
        color: "#808080",
        gradient: "linear-gradient(45deg, #808080, #A9A9A9)",
    },
    "PLAN 3,500": {
        label: "Plan 3,500",
        color: "#696969",
        gradient: "linear-gradient(45deg, #696969, #A9A9A9)",
    },
    "PLAN 3,200": {
        label: "Plan 3,200",
        color: "#A9A9A9",
        gradient: "linear-gradient(45deg, #A9A9A9, #C0C0C0)",
    },
    "PLAN 2,800": {
        label: "Plan 2,800",
        color: "#708090",
        gradient: "linear-gradient(45deg, #708090, #B0C4DE)",
    },
    "PLAN 1,500": {
        label: "Plan 1,500",
        color: "#4682B4",
        gradient: "linear-gradient(45deg, #4682B4, #87CEEB)",
    },
    "PLAN 700": {
        label: "Plan 700",
        color: "#B0C4DE",
        gradient: "linear-gradient(45deg, #B0C4DE, #D3D3D3)",
    },
    "PLAN 600": {
        label: "Plan 600",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "PLAN 550": {
        label: "Plan 550",
        color: "#1E90FF",
        gradient: "linear-gradient(45deg, #1E90FF, #87CEEB)",
    },
    "PLAN 500": {
        label: "Plan 500",
        color: "#483D8B",
        gradient: "linear-gradient(45deg, #483D8B, #B0C4DE)",
    },
    "PLAN 650": {
        label: "Plan 650",
        color: "#6A5ACD",
        gradient: "linear-gradient(45deg, #6A5ACD, #B0C4DE)",
    },
    "test sob 3": {
        label: "Test Sob 3",
        color: "#FF4500",
        gradient: "linear-gradient(45deg, #FF4500, #FFA07A)",
    },
    Dependent3: {
        label: "Dependent 3",
        color: "#FFA500",
        gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)",
    },
    Ward: {
        label: "Ward",
        color: "#228B22",
        gradient: "linear-gradient(45deg, #228B22, #66CDAA)",
    },
    "Semi Private": {
        label: "Semi Private",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    "Regular Private": {
        label: "Regular Private",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "Large Private": {
        label: "Large Private",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "plan 43,750": {
        label: "Plan 43,750",
        color: "#808080",
        gradient: "linear-gradient(45deg, #808080, #A9A9A9)",
    },
    "plan 37500": {
        label: "Plan 37,500",
        color: "#696969",
        gradient: "linear-gradient(45deg, #696969, #A9A9A9)",
    },
    "plan 31250": {
        label: "Plan 31,250",
        color: "#A9A9A9",
        gradient: "linear-gradient(45deg, #A9A9A9, #C0C0C0)",
    },
    "OPEN PRIVATE - 150,000": {
        label: "Open Private - 150,000",
        color: "#4682B4",
        gradient: "linear-gradient(45deg, #4682B4, #87CEEB)",
    },
    "Rank & File A": {
        label: "Rank & File A",
        color: "#228B22",
        gradient: "linear-gradient(45deg, #228B22, #66CDAA)",
    },
    "Supervisor A": {
        label: "Supervisor A",
        color: "#008080",
        gradient: "linear-gradient(45deg, #008080, #20B2AA)",
    },
    "Manager/Department Head B": {
        label: "Manager/Department Head B",
        color: "#008080",
        gradient: "linear-gradient(45deg, #008080, #20B2AA)",
    },
    "Manager/Department Head": {
        label: "Manager/Department Head",
        color: "#008080",
        gradient: "linear-gradient(45deg, #008080, #20B2AA)",
    },
    "Plan 4": {
        label: "Plan 4",
        color: "#708090",
        gradient: "linear-gradient(45deg, #708090, #B0C4DE)",
    },
    "SEMI PRIVATE - 100,000": {
        label: "Semi Private - 100,000",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    "SEMI PRIVATE - 80,000": {
        label: "Semi Private - 80,000",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    "plan 31,250": {
        label: "Plan 31,250",
        color: "#A9A9A9",
        gradient: "linear-gradient(45deg, #A9A9A9, #C0C0C0)",
    },
    "OPEN PRIVATE - 110,000": {
        label: "Open Private - 110,000",
        color: "#4682B4",
        gradient: "linear-gradient(45deg, #4682B4, #87CEEB)",
    },
    "SEMI-PRIVATE - 95,000": {
        label: "Semi-Private - 95,000",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    Essential: {
        label: "Essential",
        color: "#228B22",
        gradient: "linear-gradient(45deg, #228B22, #66CDAA)",
    },
    Comprehensive: {
        label: "Comprehensive",
        color: "#2F4F4F",
        gradient: "linear-gradient(45deg, #2F4F4F, #708090)",
    },
    Supreme: {
        label: "Supreme",
        color: "#FFD700",
        gradient: "linear-gradient(45deg, #FFD700, #FFA500)",
    },
    "PLAN 6": {
        label: "Plan 6",
        color: "#4682B4",
        gradient: "linear-gradient(45deg, #4682B4, #87CEEB)",
    },
    "PLAN 7": {
        label: "Plan 7",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "PLAN 8": {
        label: "Plan 8",
        color: "#1E90FF",
        gradient: "linear-gradient(45deg, #1E90FF, #87CEEB)",
    },
    "AMDL Plan": {
        label: "AMDL Plan",
        color: "#228B22",
        gradient: "linear-gradient(45deg, #228B22, #66CDAA)",
    },
    "CORPORATE GOLD PRINCIPAL- SEMI-PRIVATE (2)": {
        label: "Corporate Gold Principal - Semi-Private (2)",
        color: "#FFD700",
        gradient: "linear-gradient(45deg, #FFD700, #FFA500)",
    },
    "REGULAR PRIVATE - 200,000": {
        label: "Regular Private - 200,000",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "SEMI-PRIVATE - 125,000": {
        label: "Semi-Private - 125,000",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    "SEMI-PRIVATE - 80,000": {
        label: "Semi-Private - 80,000",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    "OPEN PRIVATE - 200,000": {
        label: "Open Private - 200,000",
        color: "#4682B4",
        gradient: "linear-gradient(45deg, #4682B4, #87CEEB)",
    },
    "REGULAR PRIVATE - 200,000 (2)": {
        label: "Regular Private - 200,000 (2)",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "REGULAR PRIVATE - 150,000": {
        label: "Regular Private - 150,000",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "SEMI-PRIVATE - 125,000 (2)": {
        label: "Semi-Private - 125,000 (2)",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    "SEMI-PRIVATE - 100,000 (2)": {
        label: "Semi-Private - 100,000 (2)",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    "SEMI- PRIVATE - 80,000": {
        label: "Semi-Private - 80,000",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    "REGULAR PRIVATE (2)- 100,000 (PRINCIPAL)": {
        label: "Regular Private (2) - 100,000 (Principal)",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "PLAN 3 LANDBASED, STAFF": {
        label: "Plan 3 Landbased, Staff",
        color: "#228B22",
        gradient: "linear-gradient(45deg, #228B22, #66CDAA)",
    },
    "UNIFORM PLAN": {
        label: "Uniform Plan",
        color: "#808080",
        gradient: "linear-gradient(45deg, #808080, #A9A9A9)",
    },
    "PRINCIPAL PLAN": {
        label: "Principal Plan",
        color: "#1E90FF",
        gradient: "linear-gradient(45deg, #1E90FF, #87CEEB)",
    },
    "REGULAR PRIVATE - 180,000": {
        label: "Regular Private - 180,000",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "REGULAR PRIVATE - 140,000": {
        label: "Regular Private - 140,000",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "SMALL PRIVATE - 120,000": {
        label: "Small Private - 120,000",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "SEMI-PRIVATE - 120,000": {
        label: "Semi-Private - 120,000",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    "LARGE PRIVATE - 200,000 (2)": {
        label: "Large Private - 200,000 (2)",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "REGULAR PRIVATE - 180,000 (2)": {
        label: "Regular Private - 180,000 (2)",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "REGULAR PRIVATE - 140,000 (2)": {
        label: "Regular Private - 140,000 (2)",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "SMALL PRIVATE - 120,000 (2)": {
        label: "Small Private - 120,000 (2)",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "SEMI-PRIVATE - 120,000 (2)": {
        label: "Semi-Private - 120,000 (2)",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    "WARD - 100,000": {
        label: "Ward - 100,000",
        color: "#228B22",
        gradient: "linear-gradient(45deg, #228B22, #66CDAA)",
    },
    "Managers/Supervisors A": {
        label: "Managers/Supervisors A",
        color: "#008080",
        gradient: "linear-gradient(45deg, #008080, #20B2AA)",
    },
    "WARD - 100,000(2)": {
        label: "Ward - 100,000 (2)",
        color: "#228B22",
        gradient: "linear-gradient(45deg, #228B22, #66CDAA)",
    },
    "SEMI-PRIVATE - 46,068": {
        label: "Semi-Private - 46,068",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    "SEMI-PRIVATE - 42,425": {
        label: "Semi-Private - 42,425",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    "SEMI-PRIVATE - 42,164": {
        label: "Semi-Private - 42,164",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    "Dependent 3": {
        label: "Dependent 3",
        color: "#FFA500",
        gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)",
    },
    "REGULAR PRIVATE - 38,630": {
        label: "Regular Private - 38,630",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    TEST: {
        label: "Test",
        color: "#FF4500",
        gradient: "linear-gradient(45deg, #FF4500, #FFA07A)",
    },
    "SEMI-PRIVATE - 36,959": {
        label: "Semi-Private - 36,959",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    "REGULAR PRIVATE - 30,959.00": {
        label: "Regular Private - 30,959.00",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "SEMI-PRIVATE - 20,548": {
        label: "Semi-Private - 20,548",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    "PRIVATE - 120,000": {
        label: "Private - 120,000",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "WARD - 60,000": {
        label: "Ward - 60,000",
        color: "#228B22",
        gradient: "linear-gradient(45deg, #228B22, #66CDAA)",
    },
    "SEMI-PRIVATE -26,027": {
        label: "Semi-Private - 26,027",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    "Ward Plan": {
        label: "Ward Plan",
        color: "#228B22",
        gradient: "linear-gradient(45deg, #228B22, #66CDAA)",
    },
    "SEMI-PRIVATE - 25,507": {
        label: "Semi-Private - 25,507",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    "PLAN - 50,000": {
        label: "Plan - 50,000",
        color: "#808080",
        gradient: "linear-gradient(45deg, #808080, #A9A9A9)",
    },
    "PLAN - 35,000": {
        label: "Plan - 35,000",
        color: "#696969",
        gradient: "linear-gradient(45deg, #696969, #A9A9A9)",
    },
    "OPEN PRIVATE - 120,000": {
        label: "Open Private - 120,000",
        color: "#4682B4",
        gradient: "linear-gradient(45deg, #4682B4, #87CEEB)",
    },
    "SEMI-PRIVATE - 23,945": {
        label: "Semi-Private - 23,945",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    "Supervisor/ Manager": {
        label: "Supervisor/Manager",
        color: "#008080",
        gradient: "linear-gradient(45deg, #008080, #20B2AA)",
    },
    Ward: {
        label: "Ward",
        color: "#228B22",
        gradient: "linear-gradient(45deg, #228B22, #66CDAA)",
    },
    Private: {
        label: "Private",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    Supervisors: {
        label: "Supervisors",
        color: "#008080",
        gradient: "linear-gradient(45deg, #008080, #20B2AA)",
    },
    "SEMI-PRIVATE - 7,288": {
        label: "Semi-Private - 7,288",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    "SEMI PRIVATE 40,192.00": {
        label: "Semi Private - 40,192.00",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    "OPEN PRIVATE - 130,000": {
        label: "Open Private - 130,000",
        color: "#4682B4",
        gradient: "linear-gradient(45deg, #4682B4, #87CEEB)",
    },
    "SEMI-PRIVATE - 100,000": {
        label: "Semi-Private - 100,000",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    "Semi-Private 80,000": {
        label: "Semi-Private - 80,000",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    "Semi-Private 100,000": {
        label: "Semi-Private - 100,000",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    "REGULAR PRIVATE 120,000": {
        label: "Regular Private - 120,000",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "Semi-Private 80000": {
        label: "Semi-Private - 80,000",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    "LARGE PRIVATE 500,000": {
        label: "Large Private - 500,000",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "PLAN II": {
        label: "Plan II",
        color: "#696969",
        gradient: "linear-gradient(45deg, #696969, #A9A9A9)",
    },
    "PLAN III-A": {
        label: "Plan III-A",
        color: "#A9A9A9",
        gradient: "linear-gradient(45deg, #A9A9A9, #C0C0C0)",
    },
    "PLAN III-B": {
        label: "Plan III-B",
        color: "#708090",
        gradient: "linear-gradient(45deg, #708090, #B0C4DE)",
    },
    "PRIVATE - 100,000": {
        label: "Private - 100,000",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "REGULAR PRIVATE - 21,644": {
        label: "Regular Private - 21,644",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "LEVEL 1": {
        label: "Level 1",
        color: "#808080",
        gradient: "linear-gradient(45deg, #808080, #A9A9A9)",
    },
    "LEVEL 2": {
        label: "Level 2",
        color: "#696969",
        gradient: "linear-gradient(45deg, #696969, #A9A9A9)",
    },
    "PLAN 10000": {
        label: "Plan 10,000",
        color: "#4682B4",
        gradient: "linear-gradient(45deg, #4682B4, #87CEEB)",
    },
    "PLAN 95,000.00": {
        label: "Plan 95,000.00",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    "PLAN 100,000.00": {
        label: "Plan 100,000.00",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "PLAN 105,000.00": {
        label: "Plan 105,000.00",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "PLAN 125,000.00": {
        label: "Plan 125,000.00",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "PLAN 150,000.00": {
        label: "Plan 150,000.00",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "PLAN 170,000.00": {
        label: "Plan 170,000.00",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "PLAN 200,000.00": {
        label: "Plan 200,000.00",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "PLAN 235,000.00": {
        label: "Plan 235,000.00",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "PLAN 300,000.00": {
        label: "Plan 300,000.00",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "OPEN PRIVATE - 36,986": {
        label: "Open Private - 36,986",
        color: "#4682B4",
        gradient: "linear-gradient(45deg, #4682B4, #87CEEB)",
    },
    plan1: {
        label: "Plan 1",
        color: "#808080",
        gradient: "linear-gradient(45deg, #808080, #A9A9A9)",
    },
    "OPEN PRIVATE - 48,329": {
        label: "Open Private - 48,329",
        color: "#4682B4",
        gradient: "linear-gradient(45deg, #4682B4, #87CEEB)",
    },
    "SEMI-PRIVATE - 70,000": {
        label: "Semi-Private - 70,000",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    "INDIVIDUAL GOLD - WARD(2)": {
        label: "Individual Gold - Ward (2)",
        color: "#FFD700",
        gradient: "linear-gradient(45deg, #FFD700, #FFA500)",
    },
    "INDIVIDUAL (4) - PRIVATE": {
        label: "Individual (4) - Private",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "REGULAR PRIVATE - 100,000(2)": {
        label: "Regular Private - 100,000 (2)",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "REGULAR PRIVATE - 100,000(3)": {
        label: "Regular Private - 100,000 (3)",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "REGULAR PRIVATE (3) - 100,000": {
        label: "Regular Private (3) - 100,000",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    FTW: {
        label: "FTW",
        color: "#FF4500",
        gradient: "linear-gradient(45deg, #FF4500, #FFA07A)",
    },
    TEST1: {
        label: "Test 1",
        color: "#FF4500",
        gradient: "linear-gradient(45deg, #FF4500, #FFA07A)",
    },
    "REGULAR PRIVATE (2) - 200,000": {
        label: "Regular Private (2) - 200,000",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "REGULAR PRIVATE (2) - 120,000": {
        label: "Regular Private (2) - 120,000",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "SEMI-PRIVATE (2) - 70,000": {
        label: "Semi-Private (2) - 70,000",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    "WARD (2) - 60,000": {
        label: "Ward (2) - 60,000",
        color: "#228B22",
        gradient: "linear-gradient(45deg, #228B22, #66CDAA)",
    },
    "PLAN 500": {
        label: "Plan 500",
        color: "#808080",
        gradient: "linear-gradient(45deg, #808080, #A9A9A9)",
    },
    "PLAN 300": {
        label: "Plan 300",
        color: "#696969",
        gradient: "linear-gradient(45deg, #696969, #A9A9A9)",
    },
    "PLAN 100": {
        label: "Plan 100",
        color: "#A9A9A9",
        gradient: "linear-gradient(45deg, #A9A9A9, #C0C0C0)",
    },
    "SEMI-PRIVATE-12,082": {
        label: "Semi-Private - 12,082",
        color: "#32CD32",
        gradient: "linear-gradient(45deg, #32CD32, #90EE90)",
    },
    "CLASS 1 - 200,000": {
        label: "Class 1 - 200,000",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "CLASS 2 - 150,000": {
        label: "Class 2 - 150,000",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "CLASS 3 - 100,000": {
        label: "Class 3 - 100,000",
        color: "#4169E1",
        gradient: "linear-gradient(45deg, #4169E1, #87CEFA)",
    },
    "CLASS 4 - 60,000": {
        label: "Class 4 - 60,000",
        color: "#228B22",
        gradient: "linear-gradient(45deg, #228B22, #66CDAA)",
    },
    "CLASS 4 - 60,000": { label: "Class 4 - 60,000", color: "#228B22", gradient: "linear-gradient(45deg, #228B22, #66CDAA)" },
    "REGULAR PRIVATE - 48,767": { label: "Regular Private - 48,767", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "PLAN 62.5K": { label: "Plan 62.5K", color: "#808080", gradient: "linear-gradient(45deg, #808080, #A9A9A9)" },
    "PLAN - 62,500": { label: "Plan - 62,500", color: "#696969", gradient: "linear-gradient(45deg, #696969, #A9A9A9)" },
    "OPTION 4": { label: "Option 4", color: "#4682B4", gradient: "linear-gradient(45deg, #4682B4, #87CEEB)" },
    "PLAN 20833": { label: "Plan 20,833", color: "#A9A9A9", gradient: "linear-gradient(45deg, #A9A9A9, #C0C0C0)" },
    "PLAN 8333": { label: "Plan 8,333", color: "#708090", gradient: "linear-gradient(45deg, #708090, #B0C4DE)" },
    "CORPORATE GOLD - OPEN PRIVATE": { label: "Corporate Gold - Open Private", color: "#FFD700", gradient: "linear-gradient(45deg, #FFD700, #FFA500)" },
    "CORPORATE GOLD PRINCIPAL- SEMI-PRIVATE": { label: "Corporate Gold Principal - Semi-Private", color: "#FFD700", gradient: "linear-gradient(45deg, #FFD700, #FFA500)" },
    "CORPORATE GOLD DEPENDENT- SEMI-PRIVATE": { label: "Corporate Gold Dependent - Semi-Private", color: "#FFD700", gradient: "linear-gradient(45deg, #FFD700, #FFA500)" },
    "PLAN  8,333.33": { label: "Plan 8,333.33", color: "#B0C4DE", gradient: "linear-gradient(45deg, #B0C4DE, #D3D3D3)" },
    "PLAN - 20,833.33": { label: "Plan - 20,833.33", color: "#4682B4", gradient: "linear-gradient(45deg, #4682B4, #87CEEB)" },
    "SEMI-PRIVATE - 47,123": { label: "Semi-Private - 47,123", color: "#32CD32", gradient: "linear-gradient(45deg, #32CD32, #90EE90)" },
    "Manager - 108,750.00": { label: "Manager - 108,750.00", color: "#008080", gradient: "linear-gradient(45deg, #008080, #20B2AA)" },
    "R&F - 56,250": { label: "R&F - 56,250", color: "#228B22", gradient: "linear-gradient(45deg, #228B22, #66CDAA)" },
    "SEMI-PRIVATE - 44,110": { label: "Semi-Private - 44,110", color: "#32CD32", gradient: "linear-gradient(45deg, #32CD32, #90EE90)" },
    "REGULAR PRIVATE - 40,274": { label: "Regular Private - 40,274", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "Managers/Supervisors B": { label: "Managers/Supervisors B", color: "#008080", gradient: "linear-gradient(45deg, #008080, #20B2AA)" },
    "Plan 56,250": { label: "Plan 56,250", color: "#808080", gradient: "linear-gradient(45deg, #808080, #A9A9A9)" },
    "GOLD (Principal)": { label: "Gold (Principal)", color: "#FFD700", gradient: "linear-gradient(45deg, #FFD700, #FFA500)" },
    "BRONZE (Principal)": { label: "Bronze (Principal)", color: "#CD7F32", gradient: "linear-gradient(45deg, #CD7F32, #8C5523)" },
    "Silver (Dependent)": { label: "Silver (Dependent)", color: "#C0C0C0", gradient: "linear-gradient(45deg, #C0C0C0, #A9A9A9)" },
    "Bronze (Dependent)": { label: "Bronze (Dependent)", color: "#CD7F32", gradient: "linear-gradient(45deg, #CD7F32, #8C5523)" },
    "MANAGER/DEPARTMENT HEAD B": { label: "Manager/Department Head B", color: "#008080", gradient: "linear-gradient(45deg, #008080, #20B2AA)" },
    "REGULAR PRIVATE - 37,534": { label: "Regular Private - 37,534", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "PCF - 75,000": { label: "PCF - 75,000", color: "#008080", gradient: "linear-gradient(45deg, #008080, #20B2AA)" },
    "Plan II": { label: "Plan II", color: "#696969", gradient: "linear-gradient(45deg, #696969, #A9A9A9)" },
    "Plan III": { label: "Plan III", color: "#A9A9A9", gradient: "linear-gradient(45deg, #A9A9A9, #C0C0C0)" },
    "REGULAR PRIVATE - 33,151": { label: "Regular Private - 33,151", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "SUPERVISOR & MANAGER": { label: "Supervisor & Manager", color: "#008080", gradient: "linear-gradient(45deg, #008080, #20B2AA)" },
    "WARD - 70,000": { label: "Ward - 70,000", color: "#228B22", gradient: "linear-gradient(45deg, #228B22, #66CDAA)" },
    "PRINCIPAL LEVEL 3 - 400,000 MBL": { label: "Principal Level 3 - 400,000 MBL", color: "#1E90FF", gradient: "linear-gradient(45deg, #1E90FF, #87CEEB)" },
    "PRINCIPAL LEVEL 3 - 170,000 MBL": { label: "Principal Level 3 - 170,000 MBL", color: "#1E90FF", gradient: "linear-gradient(45deg, #1E90FF, #87CEEB)" },
    "PRINCIPAL LEVEL 2 - 170,000 MBL": { label: "Principal Level 2 - 170,000 MBL", color: "#1E90FF", gradient: "linear-gradient(45deg, #1E90FF, #87CEEB)" },
    "PRINCIPAL LEVEL 1 - 140,000 MBL": { label: "Principal Level 1 - 140,000 MBL", color: "#1E90FF", gradient: "linear-gradient(45deg, #1E90FF, #87CEEB)" },
    "DEPENDENT LEVEL 3 - 170,000 MBL": { label: "Dependent Level 3 - 170,000 MBL", color: "#FFA500", gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)" },
    "DEPENDENT LEVEL 2 - 140,000 MBL": { label: "Dependent Level 2 - 140,000 MBL", color: "#FFA500", gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)" },
    "DEPENDENT LEVEL 1 - 120,000 MBL": { label: "Dependent Level 1 - 120,000 MBL", color: "#FFA500", gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)" },
    "PRINCIPAL  80,000 MBL": { label: "Principal 80,000 MBL", color: "#1E90FF", gradient: "linear-gradient(45deg, #1E90FF, #87CEEB)" },
    "GOLD -  200,000.00": { label: "Gold - 200,000.00", color: "#FFD700", gradient: "linear-gradient(45deg, #FFD700, #FFA500)" },
    "BRONZE -  80,000.00": { label: "Bronze - 80,000.00", color: "#CD7F32", gradient: "linear-gradient(45deg, #CD7F32, #8C5523)" },
    "Plan 1 - PRORATED  83,333": { label: "Plan 1 - Prorated 83,333", color: "#808080", gradient: "linear-gradient(45deg, #808080, #A9A9A9)" },
    "PLAN 1 - 200": { label: "Plan 1 - 200", color: "#4682B4", gradient: "linear-gradient(45deg, #4682B4, #87CEEB)" },
    "PLAN 2 - 60": { label: "Plan 2 - 60", color: "#696969", gradient: "linear-gradient(45deg, #696969, #A9A9A9)" },
    "Rank & File - Prorated 7,500": { label: "Rank & File - Prorated 7,500", color: "#228B22", gradient: "linear-gradient(45deg, #228B22, #66CDAA)" },
    "AGRICOOPHEALTH -  100,000.00": { label: "Agricoophealth - 100,000.00", color: "#228B22", gradient: "linear-gradient(45deg, #228B22, #66CDAA)" },
    "WARD - 30K": { label: "Ward - 30K", color: "#228B22", gradient: "linear-gradient(45deg, #228B22, #66CDAA)" },
    "Semi Private-50K": { label: "Semi Private - 50K", color: "#32CD32", gradient: "linear-gradient(45deg, #32CD32, #90EE90)" },
    "OPEN Private-300K": { label: "Open Private - 300K", color: "#4682B4", gradient: "linear-gradient(45deg, #4682B4, #87CEEB)" },
    "SEMI-PRIVATE - 50,000": { label: "Semi-Private - 50,000", color: "#32CD32", gradient: "linear-gradient(45deg, #32CD32, #90EE90)" },
    "SEMI-PRIVATE - 40,000": { label: "Semi-Private - 40,000", color: "#32CD32", gradient: "linear-gradient(45deg, #32CD32, #90EE90)" },
    "PLAN 1 - PRO RATED 15K": { label: "Plan 1 - Pro Rated 15K", color: "#808080", gradient: "linear-gradient(45deg, #808080, #A9A9A9)" },
    "test room": { label: "Test Room", color: "#FF4500", gradient: "linear-gradient(45deg, #FF4500, #FFA07A)" },
    "test room2": { label: "Test Room 2", color: "#FF4500", gradient: "linear-gradient(45deg, #FF4500, #FFA07A)" },
    "test room3": { label: "Test Room 3", color: "#FF4500", gradient: "linear-gradient(45deg, #FF4500, #FFA07A)" },
    "testroomf": { label: "Test Room F", color: "#FF4500", gradient: "linear-gradient(45deg, #FF4500, #FFA07A)" },
    "WARD - 40K": { label: "Ward - 40K", color: "#228B22", gradient: "linear-gradient(45deg, #228B22, #66CDAA)" },
    "SEMI PRIVATE - 80K": { label: "Semi Private - 80K", color: "#32CD32", gradient: "linear-gradient(45deg, #32CD32, #90EE90)" },
    "REGULAR Private - 120K": { label: "Regular Private - 120K", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "Officers": { label: "Officers", color: "#4682B4", gradient: "linear-gradient(45deg, #4682B4, #87CEEB)" },
    "Officers 2": { label: "Officers 2", color: "#4682B4", gradient: "linear-gradient(45deg, #4682B4, #87CEEB)" },
    "Executive 3": { label: "Executive 3", color: "#2F4F4F", gradient: "linear-gradient(45deg, #2F4F4F, #708090)" },
    "Executive 2": { label: "Executive 2", color: "#2F4F4F", gradient: "linear-gradient(45deg, #2F4F4F, #708090)" },
    "Executive 1": { label: "Executive 1", color: "#2F4F4F", gradient: "linear-gradient(45deg, #2F4F4F, #708090)" },
    "SeaInsure Major Medical Cover - Booster 500K": { label: "SeaInsure Major Medical Cover - Booster 500K", color: "#228B22", gradient: "linear-gradient(45deg, #228B22, #66CDAA)" },
    "SeaInsure Major Medical Cover - Booster 1M": { label: "SeaInsure Major Medical Cover - Booster 1M", color: "#228B22", gradient: "linear-gradient(45deg, #228B22, #66CDAA)" },
    "SeaInsure Major Medical Cover - Booster 2M": { label: "SeaInsure Major Medical Cover - Booster 2M", color: "#228B22", gradient: "linear-gradient(45deg, #228B22, #66CDAA)" },
    "SeaInsure Major Medical Cover - Basic 500k": { label: "SeaInsure Major Medical Cover - Basic 500K", color: "#228B22", gradient: "linear-gradient(45deg, #228B22, #66CDAA)" },
    "SeaInsure Major Medical Cover - Basic 1M": { label: "SeaInsure Major Medical Cover - Basic 1M", color: "#228B22", gradient: "linear-gradient(45deg, #228B22, #66CDAA)" },
    "SeaInsure Major Medical Cover - Basic 2M": { label: "SeaInsure Major Medical Cover - Basic 2M", color: "#228B22", gradient: "linear-gradient(45deg, #228B22, #66CDAA)" },
    "EXECUTIVE - 400,000 MBL": { label: "Executive - 400,000 MBL", color: "#2F4F4F", gradient: "linear-gradient(45deg, #2F4F4F, #708090)" },
    "PLAN 1 -  100,000.00": { label: "Plan 1 - 100,000.00", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "Pro-Rated MBL  -  16,667": { label: "Pro-Rated MBL - 16,667", color: "#FF69B4", gradient: "linear-gradient(45deg, #FF69B4, #FFB6C1)" },
    "Regular Private - 200K": { label: "Regular Private - 200K", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "PRORATED -  20,833": { label: "Prorated - 20,833", color: "#808080", gradient: "linear-gradient(45deg, #808080, #A9A9A9)" },
    "Manager -  90,000  (PRORATED)": { label: "Manager - 90,000 (Prorated)", color: "#008080", gradient: "linear-gradient(45deg, #008080, #20B2AA)" },
    "PCF -  60,000  (PRORATED)": { label: "PCF - 60,000 (Prorated)", color: "#008080", gradient: "linear-gradient(45deg, #008080, #20B2AA)" },
    "PCF -  80,000 (PRORATED)": { label: "PCF - 80,000 (Prorated)", color: "#008080", gradient: "linear-gradient(45deg, #008080, #20B2AA)" },
    "PLAN 1 -  180,000.00": { label: "Plan 1 - 180,000.00", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "NI - MEDICAL PRINCIPAL -5": { label: "NI - Medical Principal - 5", color: "#1E90FF", gradient: "linear-gradient(45deg, #1E90FF, #87CEEB)" },
    "WARD - 30K ABL": { label: "Ward - 30K ABL", color: "#228B22", gradient: "linear-gradient(45deg, #228B22, #66CDAA)" },
    "PLAN 3 - 150": { label: "Plan 3 - 150", color: "#A9A9A9", gradient: "linear-gradient(45deg, #A9A9A9, #C0C0C0)" },
    "PLAN 4 - 100": { label: "Plan 4 - 100", color: "#708090", gradient: "linear-gradient(45deg, #708090, #B0C4DE)" },
    "SEMI PRIVATE 70,000": { label: "Semi Private - 70,000", color: "#32CD32", gradient: "linear-gradient(45deg, #32CD32, #90EE90)" },
    "REGULAR PRIVATE 100,000": { label: "Regular Private - 100,000", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "REGULAR PRIVATE-180,000": { label: "Regular Private - 180,000", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "OPEN  PRIVATE-250,000": { label: "Open Private - 250,000", color: "#4682B4", gradient: "linear-gradient(45deg, #4682B4, #87CEEB)" },
    "PLAN 1 WARD - 30K ABL": { label: "Plan 1 Ward - 30K ABL", color: "#228B22", gradient: "linear-gradient(45deg, #228B22, #66CDAA)" },
    "PLAN 2 WARD - 30K MBL": { label: "Plan 2 Ward - 30K MBL", color: "#228B22", gradient: "linear-gradient(45deg, #228B22, #66CDAA)" },
    "PCF -  9,167": { label: "PCF - 9,167", color: "#008080", gradient: "linear-gradient(45deg, #008080, #20B2AA)" },
    "Supervisor -   11,667": { label: "Supervisor - 11,667", color: "#008080", gradient: "linear-gradient(45deg, #008080, #20B2AA)" },
    "PRORATED 3K": { label: "Prorated 3K", color: "#808080", gradient: "linear-gradient(45deg, #808080, #A9A9A9)" },
    "PRORATED 1.5K": { label: "Prorated 1.5K", color: "#696969", gradient: "linear-gradient(45deg, #696969, #A9A9A9)" },
    "LARGE PRIVATE - 120,000": { label: "Large Private - 120,000", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "LARGE PRIVATE - 56,548": { label: "Large Private - 56,548", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "SEMI-PRIVATE - 34,795": { label: "Semi-Private - 34,795", color: "#32CD32", gradient: "linear-gradient(45deg, #32CD32, #90EE90)" },
    "SEMI-PRIVATE (2) - 90,000": { label: "Semi-Private (2) - 90,000", color: "#32CD32", gradient: "linear-gradient(45deg, #32CD32, #90EE90)" },
    "LEVEL V 	(100,000)": { label: "Level V (100,000)", color: "#4682B4", gradient: "linear-gradient(45deg, #4682B4, #87CEEB)" },
    "NI-MEDICAL PRINCIPAL (BELER)": { label: "NI-Medical Principal (Beler)", color: "#1E90FF", gradient: "linear-gradient(45deg, #1E90FF, #87CEEB)" },
    "NI-MEDICAL DEPENDENT 1 (BELER)": { label: "NI-Medical Dependent 1 (Beler)", color: "#FFA500", gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)" },
    "NI-MEDICAL DEPENDENT 2 (BELER)": { label: "NI-Medical Dependent 2 (Beler)", color: "#FFA500", gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)" },
    "NI-MEDICAL PRINCIPAL (ELEFAN)": { label: "NI-Medical Principal (Elefan)", color: "#1E90FF", gradient: "linear-gradient(45deg, #1E90FF, #87CEEB)" },
    "NI-MEDICAL PRINCIPAL (SAYSON, RUSTAN)": { label: "NI-Medical Principal (Sayson, Rustan)", color: "#1E90FF", gradient: "linear-gradient(45deg, #1E90FF, #87CEEB)" },
    "DEPENDENT 	(SAYSON, RUSTAN)": { label: "Dependent (Sayson, Rustan)", color: "#FFA500", gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)" },
    "NI-MEDICAL PRINCIPAL (SAYSON, MARY GRACE)": { label: "NI-Medical Principal (Sayson, Mary Grace)", color: "#1E90FF", gradient: "linear-gradient(45deg, #1E90FF, #87CEEB)" },
    "DEPENDENT 1 (SAYSON, MARY GRACE)": { label: "Dependent 1 (Sayson, Mary Grace)", color: "#FFA500", gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)" },
    "DEPENDENT 2 (SAYSON, MARY GRACE)": { label: "Dependent 2 (Sayson, Mary Grace)", color: "#FFA500", gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)" },
    "WARD - 30K MBL": { label: "Ward - 30K MBL", color: "#228B22", gradient: "linear-gradient(45deg, #228B22, #66CDAA)" },
    "OPEN  Private-200K": { label: "Open Private - 200K", color: "#4682B4", gradient: "linear-gradient(45deg, #4682B4, #87CEEB)" },
    "PRO RATED -   41,667": { label: "Pro Rated - 41,667", color: "#808080", gradient: "linear-gradient(45deg, #808080, #A9A9A9)" },
    "PLAN 35K": { label: "Plan 35K", color: "#696969", gradient: "linear-gradient(45deg, #696969, #A9A9A9)" },
    "PLAN 5 - REG PRIVATE 250K": { label: "Plan 5 - Reg Private 250K", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "PLAN 5 - REG PRIVATE 300K": { label: "Plan 5 - Reg Private 300K", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "PLAN 5 - REG PRIVATE 400K": { label: "Plan 5 - Reg Private 400K", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "PLAN 1 - 60K": { label: "Plan 1 - 60K", color: "#808080", gradient: "linear-gradient(45deg, #808080, #A9A9A9)" },
    "SEMI PRIVATE 80,000": { label: "Semi Private - 80,000", color: "#32CD32", gradient: "linear-gradient(45deg, #32CD32, #90EE90)" },
    "SEMI PRIVATE 100,000": { label: "Semi Private - 100,000", color: "#32CD32", gradient: "linear-gradient(45deg, #32CD32, #90EE90)" },
    "LARGE PRIVATE 200,000": { label: "Large Private - 200,000", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "LARGE PRIVATE 250,000": { label: "Large Private - 250,000", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "PLAN 150K": { label: "Plan 150K", color: "#4682B4", gradient: "linear-gradient(45deg, #4682B4, #87CEEB)" },
    "PLAN 40K": { label: "Plan 40K", color: "#696969", gradient: "linear-gradient(45deg, #696969, #A9A9A9)" },
    "PLAN 1 - WARD 50K": { label: "Plan 1 - Ward 50K", color: "#228B22", gradient: "linear-gradient(45deg, #228B22, #66CDAA)" },
    "Plan 50": { label: "Plan 50", color: "#808080", gradient: "linear-gradient(45deg, #808080, #A9A9A9)" },
    "Plan 70": { label: "Plan 70", color: "#A9A9A9", gradient: "linear-gradient(45deg, #A9A9A9, #C0C0C0)" },
    "Plan 80": { label: "Plan 80", color: "#708090", gradient: "linear-gradient(45deg, #708090, #B0C4DE)" },
    "Plan 120": { label: "Plan 120", color: "#4682B4", gradient: "linear-gradient(45deg, #4682B4, #87CEEB)" },
    "Plan 150": { label: "Plan 150", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "Plan 180": { label: "Plan 180", color: "#1E90FF", gradient: "linear-gradient(45deg, #1E90FF, #87CEEB)" },
    "Plan 200": { label: "Plan 200", color: "#483D8B", gradient: "linear-gradient(45deg, #483D8B, #B0C4DE)" },
    "Plan 250": { label: "Plan 250", color: "#6A5ACD", gradient: "linear-gradient(45deg, #6A5ACD, #B0C4DE)" },
    "PRO RATED MBL   62,500": { label: "Pro Rated MBL 62,500", color: "#FF69B4", gradient: "linear-gradient(45deg, #FF69B4, #FFB6C1)" },
    "Plan 60": { label: "Plan 60", color: "#B0C4DE", gradient: "linear-gradient(45deg, #B0C4DE, #D3D3D3)" },
    "PLAN 400": { label: "Plan 400", color: "#4682B4", gradient: "linear-gradient(45deg, #4682B4, #87CEEB)" },
    "PLAN 750": { label: "Plan 750", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "PLAN 1.5M": { label: "Plan 1.5M", color: "#1E90FF", gradient: "linear-gradient(45deg, #1E90FF, #87CEEB)" },
    "Semi-Private Open": { label: "Semi-Private Open", color: "#32CD32", gradient: "linear-gradient(45deg, #32CD32, #90EE90)" },
    "Small-Private Open": { label: "Small-Private Open", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "Small Suite": { label: "Small Suite", color: "#483D8B", gradient: "linear-gradient(45deg, #483D8B, #B0C4DE)" },
    "WARD-50,000": { label: "Ward - 50,000", color: "#228B22", gradient: "linear-gradient(45deg, #228B22, #66CDAA)" },
    "SEMI-PRIVATE 1 -  80,000.00": { label: "Semi-Private 1 - 80,000.00", color: "#32CD32", gradient: "linear-gradient(45deg, #32CD32, #90EE90)" },
    "SEMI-PRIVATE 2 -  100,000.00": { label: "Semi-Private 2 - 100,000.00", color: "#32CD32", gradient: "linear-gradient(45deg, #32CD32, #90EE90)" },
    "REGULAR PRIVATE -  120,000.00": { label: "Regular Private - 120,000.00", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "OPEN PRIVATE -  150,000.00": { label: "Open Private - 150,000.00", color: "#4682B4", gradient: "linear-gradient(45deg, #4682B4, #87CEEB)" },
    "OPEN PRIVATE -  200,000.00": { label: "Open Private - 200,000.00", color: "#4682B4", gradient: "linear-gradient(45deg, #4682B4, #87CEEB)" },
    "PLAN 1,000/60k": { label: "Plan 1,000/60K", color: "#808080", gradient: "linear-gradient(45deg, #808080, #A9A9A9)" },
    "PLAN 1,200/80k": { label: "Plan 1,200/80K", color: "#696969", gradient: "linear-gradient(45deg, #696969, #A9A9A9)" },
    "PLAN 1,400/100k": { label: "Plan 1,400/100K", color: "#A9A9A9", gradient: "linear-gradient(45deg, #A9A9A9, #C0C0C0)" },
    "PLAN 1,600/150k - EXTENDED FAMILY MEMBER (EFM) / O": { label: "Plan 1,600/150K - EFM/O", color: "#FFA500", gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)" },
    "PLAN 2,000/200k": { label: "Plan 2,000/200K", color: "#4682B4", gradient: "linear-gradient(45deg, #4682B4, #87CEEB)" },
    "PLAN 1,000/100k": { label: "Plan 1,000/100K", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "PLAN 2,200/250k": { label: "Plan 2,200/250K", color: "#1E90FF", gradient: "linear-gradient(45deg, #1E90FF, #87CEEB)" },
    "PLAN 1,200/150k": { label: "Plan 1,200/150K", color: "#483D8B", gradient: "linear-gradient(45deg, #483D8B, #B0C4DE)" },
    "PLAN 2,500/300k - EXTENDED FAMILY MEMBER (EFM) / O": { label: "Plan 2,500/300K - EFM/O", color: "#FFA500", gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)" },
    "PLAN 3,000/400k": { label: "Plan 3,000/400K", color: "#6A5ACD", gradient: "linear-gradient(45deg, #6A5ACD, #B0C4DE)" },
    "PLAN 1,400/200k": { label: "Plan 1,400/200K", color: "#4682B4", gradient: "linear-gradient(45deg, #4682B4, #87CEEB)" },
    "PLAN 1,800/250k": { label: "Plan 1,800/250K", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "PLAN 1,000/60k - EXTENDED FAMILY MEMBER (EFM) / OT": { label: "Plan 1,000/60K - EFM/OT", color: "#FFA500", gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)" },
    "PLAN 2,400/300k": { label: "Plan 2,400/300K", color: "#1E90FF", gradient: "linear-gradient(45deg, #1E90FF, #87CEEB)" },
    "PLAN 1,200/80k - EXTENDED FAMILY MEMBER (EFM) / OT": { label: "Plan 1,200/80K - EFM/OT", color: "#FFA500", gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)" },
    "PLAN 1,400/100k - EXTENDED FAMILY MEMBER (EFM) / O": { label: "Plan 1,400/100K - EFM/O", color: "#FFA500", gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)" },
    "PLAN 1,600/150k": { label: "Plan 1,600/150K", color: "#4682B4", gradient: "linear-gradient(45deg, #4682B4, #87CEEB)" },
    "PLAN 2,000/200k - EXTENDED FAMILY MEMBER (EFM) / O": { label: "Plan 2,000/200K - EFM/O", color: "#FFA500", gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)" },
    "PLAN 2,200/250k - EXTENDED FAMILY MEMBER (EFM) / O": { label: "Plan 2,200/250K - EFM/O", color: "#FFA500", gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)" },
    "PLAN 2,500/300k": { label: "Plan 2,500/300K", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "PLAN 1 -  50,000.00": { label: "Plan 1 - 50,000.00", color: "#808080", gradient: "linear-gradient(45deg, #808080, #A9A9A9)" },
    "PLAN 2 -  30,000.00": { label: "Plan 2 - 30,000.00", color: "#696969", gradient: "linear-gradient(45deg, #696969, #A9A9A9)" },
    "REGULAR PRIVATE -250,000": { label: "Regular Private - 250,000", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "INDIVIDUAL GOLD (2)- SEMI - PRIVATE": { label: "Individual Gold (2) - Semi-Private", color: "#FFD700", gradient: "linear-gradient(45deg, #FFD700, #FFA500)" },
    "PLAN 1 - 150,000": { label: "Plan 1 - 150,000", color: "#4682B4", gradient: "linear-gradient(45deg, #4682B4, #87CEEB)" },
    "PLAN 2 - 100,000": { label: "Plan 2 - 100,000", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "PLAN 3 - 60,000": { label: "Plan 3 - 60,000", color: "#228B22", gradient: "linear-gradient(45deg, #228B22, #66CDAA)" },
    "SEMI-PRIVATE - 17,534": { label: "Semi-Private - 17,534", color: "#32CD32", gradient: "linear-gradient(45deg, #32CD32, #90EE90)" },
    "Division Manager -  166,667": { label: "Division Manager - 166,667", color: "#2F4F4F", gradient: "linear-gradient(45deg, #2F4F4F, #708090)" },
    "Plan 50 - WARD": { label: "Plan 50 - Ward", color: "#228B22", gradient: "linear-gradient(45deg, #228B22, #66CDAA)" },
    "PRIVATE - 200,000": { label: "Private - 200,000", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "PRIVATE - 300,000": { label: "Private - 300,000", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "PLAN 1,000 - PRINCIPAL": { label: "Plan 1,000 - Principal", color: "#1E90FF", gradient: "linear-gradient(45deg, #1E90FF, #87CEEB)" },
    "PLAN 1,200 - PRINCIPAL": { label: "Plan 1,200 - Principal", color: "#1E90FF", gradient: "linear-gradient(45deg, #1E90FF, #87CEEB)" },
    "PLAN 1,500 - PRINCIPAL": { label: "Plan 1,500 - Principal", color: "#1E90FF", gradient: "linear-gradient(45deg, #1E90FF, #87CEEB)" },
    "PLAN 2,000 - PRINCIPAL": { label: "Plan 2,000 - Principal", color: "#1E90FF", gradient: "linear-gradient(45deg, #1E90FF, #87CEEB)" },
    "PLAN 2,500 - PRINCIPAL": { label: "Plan 2,500 - Principal", color: "#1E90FF", gradient: "linear-gradient(45deg, #1E90FF, #87CEEB)" },
    "PLAN 2,800 - PRINCIPAL": { label: "Plan 2,800 - Principal", color: "#1E90FF", gradient: "linear-gradient(45deg, #1E90FF, #87CEEB)" },
    "PLAN 3,000 - PRINCIPAL": { label: "Plan 3,000 - Principal", color: "#1E90FF", gradient: "linear-gradient(45deg, #1E90FF, #87CEEB)" },
    "PLAN 1,000 - QUALIFIED DEP": { label: "Plan 1,000 - Qualified Dep", color: "#FFA500", gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)" },
    "PLAN 1,200 - QUALIFIED DEP": { label: "Plan 1,200 - Qualified Dep", color: "#FFA500", gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)" },
    "PLAN 1,500 - QUALIFIED DEP": { label: "Plan 1,500 - Qualified Dep", color: "#FFA500", gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)" },
    "PLAN 2,000 - QUALIFIED DEP": { label: "Plan 2,000 - Qualified Dep", color: "#FFA500", gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)" },
    "PLAN 2,500 - QUALIFIED DEP": { label: "Plan 2,500 - Qualified Dep", color: "#FFA500", gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)" },
    "PLAN 2,800 - QUALIFIED DEP": { label: "Plan 2,800 - Qualified Dep", color: "#FFA500", gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)" },
    "PLAN 3,000 - QUALIFIED DEP": { label: "Plan 3,000 - Qualified Dep", color: "#FFA500", gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)" },
    "PLAN 1,500 - EFM": { label: "Plan 1,500 - EFM", color: "#FFA500", gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)" },
    "PLAN 2,800 - EFM": { label: "Plan 2,800 - EFM", color: "#FFA500", gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)" },
    "PLAN 3,000 - EFM": { label: "Plan 3,000 - EFM", color: "#FFA500", gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)" },
    "PLAN 2	- 150K": { label: "Plan 2 - 150K", color: "#4682B4", gradient: "linear-gradient(45deg, #4682B4, #87CEEB)" },
    "PLAN 3	- 130K": { label: "Plan 3 - 130K", color: "#A9A9A9", gradient: "linear-gradient(45deg, #A9A9A9, #C0C0C0)" },
    "PLAN 4	- 110K": { label: "Plan 4 - 110K", color: "#708090", gradient: "linear-gradient(45deg, #708090, #B0C4DE)" },
    "PLAN 5	- 90K": { label: "Plan 5 - 90K", color: "#4682B4", gradient: "linear-gradient(45deg, #4682B4, #87CEEB)" },
    "PLAN 6	- 70K": { label: "Plan 6 - 70K", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "REGULAR PRIVATE -300,000": { label: "Regular Private - 300,000", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "PLAN 1,000/80k": { label: "Plan 1,000/80K", color: "#808080", gradient: "linear-gradient(45deg, #808080, #A9A9A9)" },
    "PLAN 65K": { label: "Plan 65K", color: "#696969", gradient: "linear-gradient(45deg, #696969, #A9A9A9)" },
    "PLAN 80K": { label: "Plan 80K", color: "#A9A9A9", gradient: "linear-gradient(45deg, #A9A9A9, #C0C0C0)" },
    "PLAN 95K": { label: "Plan 95K", color: "#708090", gradient: "linear-gradient(45deg, #708090, #B0C4DE)" },
    "PLAN 110K": { label: "Plan 110K", color: "#4682B4", gradient: "linear-gradient(45deg, #4682B4, #87CEEB)" },
    "PLAN 125K": { label: "Plan 125K", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "PLAN 140K": { label: "Plan 140K", color: "#1E90FF", gradient: "linear-gradient(45deg, #1E90FF, #87CEEB)" },
    "PLAN 155K": { label: "Plan 155K", color: "#483D8B", gradient: "linear-gradient(45deg, #483D8B, #B0C4DE)" },
    "LC3 - PEC COVERED": { label: "LC3 - PEC Covered", color: "#228B22", gradient: "linear-gradient(45deg, #228B22, #66CDAA)" },
    "GOLD 80-40": { label: "Gold 80-40", color: "#FFD700", gradient: "linear-gradient(45deg, #FFD700, #FFA500)" },
    "Rank & File 2 - 75k": { label: "Rank & File 2 - 75K", color: "#2E8B57", gradient: "linear-gradient(45deg, #2E8B57, #98FB98)" },
    "Rank & File 2 - 75K": { label: "Rank & File 2 - 75K", color: "#2E8B57", gradient: "linear-gradient(45deg, #2E8B57, #98FB98)" },
    "Rank & File 2 - 67500": { label: "Rank & File 2 - 67,500", color: "#2E8B57", gradient: "linear-gradient(45deg, #2E8B57, #98FB98)" },
    "PLAN 1,000/60k - QD": { label: "Plan 1,000/60K - QD", color: "#FFA500", gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)" },
    "PLAN 1,000/80k - QD": { label: "Plan 1,000/80K - QD", color: "#FFA500", gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)" },
    "PLAN 1,000/100k - QD": { label: "Plan 1,000/100K - QD", color: "#FFA500", gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)" },
    "PLAN 1,200/150k - QD": { label: "Plan 1,200/150K - QD", color: "#FFA500", gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)" },
    "PLAN 1,400/200k - QD": { label: "Plan 1,400/200K - QD", color: "#FFA500", gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)" },
    "PLAN 1,800/250k - QD": { label: "Plan 1,800/250K - QD", color: "#FFA500", gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)" },
    "PLAN 2,400/300k - QD": { label: "Plan 2,400/300K - QD", color: "#FFA500", gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)" },
    "SEMI- PRIVATE -100,000": { label: "Semi-Private - 100,000", color: "#32CD32", gradient: "linear-gradient(45deg, #32CD32, #90EE90)" },
    "PLAN 4 - 150K": { label: "Plan 4 - 150K", color: "#4682B4", gradient: "linear-gradient(45deg, #4682B4, #87CEEB)" },
    "SILVER PROGRAM": { label: "Silver Program", color: "#C0C0C0", gradient: "linear-gradient(45deg, #C0C0C0, #A9A9A9)" },
    "Private - 150K": { label: "Private - 150K", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "DEPENDENT - 100K": { label: "Dependent - 100K", color: "#FFA500", gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)" },
    "PLAN 100K": { label: "Plan 100K", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "PLAN 200K": { label: "Plan 200K", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "REGULAR PRIVATE - 38,082": { label: "Regular Private - 38,082", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "LARGE PRIVATE - 29,260": { label: "Large Private - 29,260", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "REGULAR PRIVATE - 26,822": { label: "Regular Private - 26,822", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "SEMI-PRIVATE - 21945": { label: "Semi-Private - 21,945", color: "#32CD32", gradient: "linear-gradient(45deg, #32CD32, #90EE90)" },
    "Plan 40": { label: "Plan 40", color: "#808080", gradient: "linear-gradient(45deg, #808080, #A9A9A9)" },
    "PLAN 1 - 85K": { label: "Plan 1 - 85K", color: "#696969", gradient: "linear-gradient(45deg, #696969, #A9A9A9)" },
    "REGULAR PRIVATE (2) - 250,000": { label: "Regular Private (2) - 250,000", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "REGULAR PRIVATE (2) - 300,000": { label: "Regular Private (2) - 300,000", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "INDIVIDUAL  GOLD (4) -  SEMI-PRIVATE": { label: "Individual Gold (4) - Semi-Private", color: "#FFD700", gradient: "linear-gradient(45deg, #FFD700, #FFA500)" },
    "LAWINA - MIFFI LOGISTICS CO,. INC.": { label: "Lawina - Miffi Logistics Co., Inc.", color: "#228B22", gradient: "linear-gradient(45deg, #228B22, #66CDAA)" },
    "Rank & File 2 60k (PRORATED)": { label: "Rank & File 2 60K (Prorated)", color: "#2E8B57", gradient: "linear-gradient(45deg, #2E8B57, #98FB98)" },
    "PLAN 6 - 175K": { label: "Plan 6 - 175K", color: "#4682B4", gradient: "linear-gradient(45deg, #4682B4, #87CEEB)" },
    "Manager -  106,667 (PRORATED)": { label: "Manager - 106,667 (Prorated)", color: "#008080", gradient: "linear-gradient(45deg, #008080, #20B2AA)" },
    "PLAN 7 - 200k": { label: "Plan 7 - 200K", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "DLP TRANSPORT SERVICE - MEDICAL PRINCIPAL -2": { label: "DLP Transport Service - Medical Principal - 2", color: "#1E90FF", gradient: "linear-gradient(45deg, #1E90FF, #87CEEB)" },
    "SEMI-PRIVATE - 75,205": { label: "Semi-Private - 75,205", color: "#32CD32", gradient: "linear-gradient(45deg, #32CD32, #90EE90)" },
    "Plan 65": { label: "Plan 65", color: "#A9A9A9", gradient: "linear-gradient(45deg, #A9A9A9, #C0C0C0)" },
    "PLAN - 110": { label: "Plan - 110", color: "#708090", gradient: "linear-gradient(45deg, #708090, #B0C4DE)" },
    "PLAN - 140": { label: "Plan - 140", color: "#4682B4", gradient: "linear-gradient(45deg, #4682B4, #87CEEB)" },
    "PCF -  73,333": { label: "PCF - 73,333", color: "#008080", gradient: "linear-gradient(45deg, #008080, #20B2AA)" },
    "Rank & File 2 -   60,000": { label: "Rank & File 2 - 60,000", color: "#2E8B57", gradient: "linear-gradient(45deg, #2E8B57, #98FB98)" },
    "EMPLOYEE": { label: "Employee", color: "#228B22", gradient: "linear-gradient(45deg, #228B22, #66CDAA)" },
    "Rank & File 2 - 60,000": { label: "Rank & File 2 - 60,000", color: "#2E8B57", gradient: "linear-gradient(45deg, #2E8B57, #98FB98)" },
    "Rank & File 2 -   67,500": { label: "Rank & File 2 - 67,500", color: "#2E8B57", gradient: "linear-gradient(45deg, #2E8B57, #98FB98)" },
    "LARGE PRIVATE - 22,438": { label: "Large Private - 22,438", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "Plan 100 - SP": { label: "Plan 100 - SP", color: "#32CD32", gradient: "linear-gradient(45deg, #32CD32, #90EE90)" },
    "WARD - 60K (NO ACCESS)": { label: "Ward - 60K (No Access)", color: "#228B22", gradient: "linear-gradient(45deg, #228B22, #66CDAA)" },
    "SEMIPVT - 75K (NO ACCESS)": { label: "Semi Pvt - 75K (No Access)", color: "#32CD32", gradient: "linear-gradient(45deg, #32CD32, #90EE90)" },
    "SMALLPVT - 100K (NO ACCESS)": { label: "Small Pvt - 100K (No Access)", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "PRIVATE  - 200K (NO ACCESS)": { label: "Private - 200K (No Access)", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "PRIVATE - 200K": { label: "Private - 200K", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "Plan 100 - RP": { label: "Plan 100 - RP", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "SPRINT - MEDICAL PRINCIPAL -  15": { label: "Sprint - Medical Principal - 15", color: "#1E90FF", gradient: "linear-gradient(45deg, #1E90FF, #87CEEB)" },
    "Rank & File 2 - 52,500": { label: "Rank & File 2 - 52,500", color: "#2E8B57", gradient: "linear-gradient(45deg, #2E8B57, #98FB98)" },
    "Supervisor -   81,667": { label: "Supervisor - 81,667", color: "#008080", gradient: "linear-gradient(45deg, #008080, #20B2AA)" },
    "Supervisor - 81,667": { label: "Supervisor - 81,667", color: "#008080", gradient: "linear-gradient(45deg, #008080, #20B2AA)" },
    "SEMI-PRIVATE- 100,000": { label: "Semi-Private - 100,000", color: "#32CD32", gradient: "linear-gradient(45deg, #32CD32, #90EE90)" },
    "Dependent 4": { label: "Dependent 4", color: "#FFA500", gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)" },
    "PLAN 3 - 300": { label: "Plan 3 - 300", color: "#A9A9A9", gradient: "linear-gradient(45deg, #A9A9A9, #C0C0C0)" },
    "Plan 30": { label: "Plan 30", color: "#808080", gradient: "linear-gradient(45deg, #808080, #A9A9A9)" },
    "Plan 50 - SP": { label: "Plan 50 - SP", color: "#32CD32", gradient: "linear-gradient(45deg, #32CD32, #90EE90)" },
    "Semi-Private - 62,877": { label: "Semi-Private - 62,877", color: "#32CD32", gradient: "linear-gradient(45deg, #32CD32, #90EE90)" },
    "Manager -   93,333": { label: "Manager - 93,333", color: "#008080", gradient: "linear-gradient(45deg, #008080, #20B2AA)" },
    "PRORATED - 33,333": { label: "Prorated - 33,333", color: "#808080", gradient: "linear-gradient(45deg, #808080, #A9A9A9)" },
    "Plan 50 - W": { label: "Plan 50 - W", color: "#228B22", gradient: "linear-gradient(45deg, #228B22, #66CDAA)" },
    "ER CARD": { label: "ER Card", color: "#FF4500", gradient: "linear-gradient(45deg, #FF4500, #FFA07A)" },
    "DEPENDENT LEVEL 2 - 140,000": { label: "Dependent Level 2 - 140,000", color: "#FFA500", gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)" },
    "DEPENDENT LEVEl 1 - 120,000": { label: "Dependent Level 1 - 120,000", color: "#FFA500", gradient: "linear-gradient(45deg, #FFA500, #FFDAB9)" },
    "PLAN - 17,500": { label: "Plan - 17,500", color: "#696969", gradient: "linear-gradient(45deg, #696969, #A9A9A9)" },
    "Rank & File - 33,333": { label: "Rank & File - 33,333", color: "#228B22", gradient: "linear-gradient(45deg, #228B22, #66CDAA)" },
    "SEMI-PRIVATE - 75K": { label: "Semi-Private - 75K", color: "#32CD32", gradient: "linear-gradient(45deg, #32CD32, #90EE90)" },
    "SEMI-PRIVATE - 100K": { label: "Semi-Private - 100K", color: "#32CD32", gradient: "linear-gradient(45deg, #32CD32, #90EE90)" },
    "PRORATED - 36,667": { label: "Prorated - 36,667", color: "#808080", gradient: "linear-gradient(45deg, #808080, #A9A9A9)" },
    "WARD (3) - 60,000": { label: "Ward (3) - 60,000", color: "#228B22", gradient: "linear-gradient(45deg, #228B22, #66CDAA)" },
    "SEMI-PRIVATE (4) - 80,000": { label: "Semi-Private (4) - 80,000", color: "#32CD32", gradient: "linear-gradient(45deg, #32CD32, #90EE90)" },
    "SOUTHFIELD AGENCIES, INC": { label: "Southfield Agencies, Inc.", color: "#228B22", gradient: "linear-gradient(45deg, #228B22, #66CDAA)" },
    "Supervisor - 70K": { label: "Supervisor - 70K", color: "#008080", gradient: "linear-gradient(45deg, #008080, #20B2AA)" },
    "Plan 250 ,000 MBL": { label: "Plan 250,000 MBL", color: "#20B2AA", gradient: "linear-gradient(45deg, #20B2AA, #66CDAA)" },
    "Plan   75,000 MBL": { label: "Plan 75,000 MBL", color: "#20B2AA", gradient: "linear-gradient(45deg, #20B2AA, #66CDAA)" },
    "Plan 50,000 MBL": { label: "Plan 50,000 MBL", color: "#20B2AA", gradient: "linear-gradient(45deg, #20B2AA, #66CDAA)" },
    "Plan 25": { label: "Plan 25", color: "#808080", gradient: "linear-gradient(45deg, #808080, #A9A9A9)" },
    "Plan - 35 500": { label: "Plan - 35,500", color: "#696969", gradient: "linear-gradient(45deg, #696969, #A9A9A9)" },
    "Plan - 32 500": { label: "Plan - 32,500", color: "#A9A9A9", gradient: "linear-gradient(45deg, #A9A9A9, #C0C0C0)" },
    "Small Private - 70K": { label: "Small Private - 70K", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "PLAN 4 - 70": { label: "Plan 4 - 70", color: "#708090", gradient: "linear-gradient(45deg, #708090, #B0C4DE)" },
    "Rank & File 2  -   45,000": { label: "Rank & File 2 - 45,000", color: "#2E8B57", gradient: "linear-gradient(45deg, #2E8B57, #98FB98)" },
    "Rank & File 2 -   37,500": { label: "Rank & File 2 - 37,500", color: "#2E8B57", gradient: "linear-gradient(45deg, #2E8B57, #98FB98)" },
    "R&F -  36,667": { label: "R&F - 36,667", color: "#228B22", gradient: "linear-gradient(45deg, #228B22, #66CDAA)" },
    "Rank & File 2 - 30,000": { label: "Rank & File 2 - 30,000", color: "#2E8B57", gradient: "linear-gradient(45deg, #2E8B57, #98FB98)" },
    "WARD 50,000": { label: "Ward 50,000", color: "#228B22", gradient: "linear-gradient(45deg, #228B22, #66CDAA)" },
    "PLAN - 150": { label: "Plan - 150", color: "#4682B4", gradient: "linear-gradient(45deg, #4682B4, #87CEEB)" },
    "Semi-Private-37,808": { label: "Semi-Private - 37,808", color: "#32CD32", gradient: "linear-gradient(45deg, #32CD32, #90EE90)" },
    "Pro-rated MBL- 27,500": { label: "Pro-rated MBL - 27,500", color: "#FF69B4", gradient: "linear-gradient(45deg, #FF69B4, #FFB6C1)" },
    "Supervisor -   46,667": { label: "Supervisor - 46,667", color: "#008080", gradient: "linear-gradient(45deg, #008080, #20B2AA)" },
    "WARD - 8,247": { label: "Ward - 8,247", color: "#228B22", gradient: "linear-gradient(45deg, #228B22, #66CDAA)" },
    "SEMI-PRIVATE - 10,603": { label: "Semi-Private - 10,603", color: "#32CD32", gradient: "linear-gradient(45deg, #32CD32, #90EE90)" },
    "250,000.00": { label: "250,000.00", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "200,000.00": { label: "200,000.00", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "150,000.00": { label: "150,000.00", color: "#4682B4", gradient: "linear-gradient(45deg, #4682B4, #87CEEB)" },
    "100,000.00": { label: "100,000.00", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "75,000.00": { label: "75,000.00", color: "#32CD32", gradient: "linear-gradient(45deg, #32CD32, #90EE90)" },
    "50,000.00": { label: "50,000.00", color: "#228B22", gradient: "linear-gradient(45deg, #228B22, #66CDAA)" },
    "Plan - 90,000": { label: "Plan - 90,000", color: "#4682B4", gradient: "linear-gradient(45deg, #4682B4, #87CEEB)" },
    "PLAN 140": { label: "Plan 140", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "PLAN 130": { label: "Plan 130", color: "#A9A9A9", gradient: "linear-gradient(45deg, #A9A9A9, #C0C0C0)" },
    "PLAN 90": { label: "Plan 90", color: "#708090", gradient: "linear-gradient(45deg, #708090, #B0C4DE)" },
    "PLAN 110": { label: "Plan 110", color: "#4682B4", gradient: "linear-gradient(45deg, #4682B4, #87CEEB)" },
    "PLAN 170": { label: "Plan 170", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "REGULAR PRIVATE -126,027": { label: "Regular Private - 126,027", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "SMALL PRIVATE - 90,000": { label: "Small Private - 90,000", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "PLATINUM 180-40": { label: "Platinum 180-40", color: "#E5E4E2", gradient: "linear-gradient(45deg, #E5E4E2, #B0B0B0)" },
    "PLAN 1-150K": { label: "Plan 1 - 150K", color: "#4682B4", gradient: "linear-gradient(45deg, #4682B4, #87CEEB)" },
    "PLAN 1 - 80K": { label: "Plan 1 - 80K", color: "#808080", gradient: "linear-gradient(45deg, #808080, #A9A9A9)" },
    "PLAN 1 - 60K": { label: "Plan 1 - 60K", color: "#696969", gradient: "linear-gradient(45deg, #696969, #A9A9A9)" },
    "PLAN 1 - 30K": { label: "Plan 1 - 30K", color: "#A9A9A9", gradient: "linear-gradient(45deg, #A9A9A9, #C0C0C0)" },
    "SEMI-PRIVATE - 46,849": { label: "Semi-Private - 46,849", color: "#32CD32", gradient: "linear-gradient(45deg, #32CD32, #90EE90)" },
    "REGULAR PRIVATE -121,918": { label: "Regular Private - 121,918", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "PCF - 46,667": { label: "PCF - 46,667", color: "#008080", gradient: "linear-gradient(45deg, #008080, #20B2AA)" },
    "PRO RATED 150,000": { label: "Pro Rated 150,000", color: "#808080", gradient: "linear-gradient(45deg, #808080, #A9A9A9)" },
    "PLAN 75K": { label: "Plan 75K", color: "#32CD32", gradient: "linear-gradient(45deg, #32CD32, #90EE90)" },
    "PLAN 30K": { label: "Plan 30K", color: "#696969", gradient: "linear-gradient(45deg, #696969, #A9A9A9)" },
    "SEMI-PRIVATE - 21,370": { label: "Semi-Private - 21,370", color: "#32CD32", gradient: "linear-gradient(45deg, #32CD32, #90EE90)" },
    "PLAN 5 - 50": { label: "Plan 5 - 50", color: "#4682B4", gradient: "linear-gradient(45deg, #4682B4, #87CEEB)" },
    "PLAN 50K": { label: "Plan 50K", color: "#A9A9A9", gradient: "linear-gradient(45deg, #A9A9A9, #C0C0C0)" },
    "PLAN 175K": { label: "Plan 175K", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "PLAN 120K": { label: "Plan 120K", color: "#1E90FF", gradient: "linear-gradient(45deg, #1E90FF, #87CEEB)" },
    "PLAN 1 - 100K": { label: "Plan 1 - 100K", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "PLAN 1- 60K": { label: "Plan 1 - 60K", color: "#808080", gradient: "linear-gradient(45deg, #808080, #A9A9A9)" },
    "PLAN 1-30K": { label: "Plan 1 - 30K", color: "#696969", gradient: "linear-gradient(45deg, #696969, #A9A9A9)" },
    "PLAN 2- 100K": { label: "Plan 2 - 100K", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "PLAN 2- 60K": { label: "Plan 2 - 60K", color: "#A9A9A9", gradient: "linear-gradient(45deg, #A9A9A9, #C0C0C0)" },
    "PRORATED - 100,000": { label: "Prorated - 100,000", color: "#808080", gradient: "linear-gradient(45deg, #808080, #A9A9A9)" },
    "REGULAR PRIVATE -110,000": { label: "Regular Private - 110,000", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "PLAN 1 - 150": { label: "Plan 1 - 150", color: "#4682B4", gradient: "linear-gradient(45deg, #4682B4, #87CEEB)" },
    "PLAN 1 - 100": { label: "Plan 1 - 100", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "PLAN 1 - 80": { label: "Plan 1 - 80", color: "#1E90FF", gradient: "linear-gradient(45deg, #1E90FF, #87CEEB)" },
    "PLAN 1- 60": { label: "Plan 1 - 60", color: "#483D8B", gradient: "linear-gradient(45deg, #483D8B, #B0C4DE)" },
    "PLAN 1- 30": { label: "Plan 1 - 30", color: "#6A5ACD", gradient: "linear-gradient(45deg, #6A5ACD, #B0C4DE)" },
    "PLAN 2 -150": { label: "Plan 2 - 150", color: "#4682B4", gradient: "linear-gradient(45deg, #4682B4, #87CEEB)" },
    "PLAN 2 - 100": { label: "Plan 2 - 100", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "PLAN 2 - 80": { label: "Plan 2 - 80", color: "#1E90FF", gradient: "linear-gradient(45deg, #1E90FF, #87CEEB)" },
    "PLAN 2 - 30": { label: "Plan 2 - 30", color: "#483D8B", gradient: "linear-gradient(45deg, #483D8B, #B0C4DE)" },
    "REGULAR PRIVATE -102,740": { label: "Regular Private - 102,740", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "PLAN 1 - 250": { label: "Plan 1 - 250", color: "#4682B4", gradient: "linear-gradient(45deg, #4682B4, #87CEEB)" },
    "PLAN 2 - 200": { label: "Plan 2 - 200", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "PLAN 5 - 75": { label: "Plan 5 - 75", color: "#32CD32", gradient: "linear-gradient(45deg, #32CD32, #90EE90)" },
    "PLAN 6 - 50": { label: "Plan 6 - 50", color: "#228B22", gradient: "linear-gradient(45deg, #228B22, #66CDAA)" },
    "PLAN 2 - 75": { label: "Plan 2 - 75", color: "#32CD32", gradient: "linear-gradient(45deg, #32CD32, #90EE90)" },
    "PLAN 3 -50": { label: "Plan 3 - 50", color: "#228B22", gradient: "linear-gradient(45deg, #228B22, #66CDAA)" },
    "Rank & File 2 -   22,500": { label: "Rank & File 2 - 22,500", color: "#2E8B57", gradient: "linear-gradient(45deg, #2E8B57, #98FB98)" },
    "Rank & File 2 - 22,500": { label: "Rank & File 2 - 22,500", color: "#2E8B57", gradient: "linear-gradient(45deg, #2E8B57, #98FB98)" },
    "Rank & File 2 - 22500": { label: "Rank & File 2 - 22,500", color: "#2E8B57", gradient: "linear-gradient(45deg, #2E8B57, #98FB98)" },
    "Rank & File 2  - 22,500": { label: "Rank & File 2 - 22,500", color: "#2E8B57", gradient: "linear-gradient(45deg, #2E8B57, #98FB98)" },
    "PRORATED   13,333": { label: "Prorated 13,333", color: "#808080", gradient: "linear-gradient(45deg, #808080, #A9A9A9)" },
    "PRORATED -20,833": { label: "Prorated - 20,833", color: "#696969", gradient: "linear-gradient(45deg, #696969, #A9A9A9)" },
    "PRORATED -53,333": { label: "Prorated - 53,333", color: "#A9A9A9", gradient: "linear-gradient(45deg, #A9A9A9, #C0C0C0)" },
    "PRORATED -26,667": { label: "Prorated - 26,667", color: "#708090", gradient: "linear-gradient(45deg, #708090, #B0C4DE)" },
    "PLAN 165": { label: "Plan 165", color: "#4682B4", gradient: "linear-gradient(45deg, #4682B4, #87CEEB)" },
    "PLAN 190": { label: "Plan 190", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "PLAN 235": { label: "Plan 235", color: "#1E90FF", gradient: "linear-gradient(45deg, #1E90FF, #87CEEB)" },
    "PLAN 175": { label: "Plan 175", color: "#483D8B", gradient: "linear-gradient(45deg, #483D8B, #B0C4DE)" },
    "REGULAR PRIVATE - 100,000 (2)": { label: "Regular Private - 100,000 (2)", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "PRORATED 333,333": { label: "Prorated 333,333", color: "#808080", gradient: "linear-gradient(45deg, #808080, #A9A9A9)" },
    "PRORATED 40,000": { label: "Prorated 40,000", color: "#696969", gradient: "linear-gradient(45deg, #696969, #A9A9A9)" },
    "PRORATED - 35,000": { label: "Prorated - 35,000", color: "#A9A9A9", gradient: "linear-gradient(45deg, #A9A9A9, #C0C0C0)" },
    "PRORATED -40,000": { label: "Prorated - 40,000", color: "#708090", gradient: "linear-gradient(45deg, #708090, #B0C4DE)" },
    "PLAN 2 - 30K": { label: "Plan 2 - 30K", color: "#4682B4", gradient: "linear-gradient(45deg, #4682B4, #87CEEB)" },
    "PLAN 2 - 60K": { label: "Plan 2 - 60K", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "PLAN 2 - 70K": { label: "Plan 2 - 70K", color: "#1E90FF", gradient: "linear-gradient(45deg, #1E90FF, #87CEEB)" },
    "PLAN 2 - 150K": { label: "Plan 2 - 150K", color: "#483D8B", gradient: "linear-gradient(45deg, #483D8B, #B0C4DE)" },
    "PLAN 1 - 200K": { label: "Plan 1 - 200K", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "PLAN 3 - 75K": { label: "Plan 3 - 75K", color: "#32CD32", gradient: "linear-gradient(45deg, #32CD32, #90EE90)" },
    "PLAN 4 - 50K": { label: "Plan 4 - 50K", color: "#228B22", gradient: "linear-gradient(45deg, #228B22, #66CDAA)" },
    "PRORATED 150,000": { label: "Prorated 150,000", color: "#808080", gradient: "linear-gradient(45deg, #808080, #A9A9A9)" },
    "PLAN 1 -70K": { label: "Plan 1 - 70K", color: "#A9A9A9", gradient: "linear-gradient(45deg, #A9A9A9, #C0C0C0)" },
    "PLAN 2 -150K": { label: "Plan 2 - 150K", color: "#4682B4", gradient: "linear-gradient(45deg, #4682B4, #87CEEB)" },
    "PLAN 2 -30K": { label: "Plan 2 - 30K", color: "#696969", gradient: "linear-gradient(45deg, #696969, #A9A9A9)" },
    "PRORATED - 133,333.33": { label: "Prorated - 133,333.33", color: "#708090", gradient: "linear-gradient(45deg, #708090, #B0C4DE)" },
    "REGULAR PRIVATE -83,562": { label: "Regular Private - 83,562", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "PRORATED 75,000": { label: "Prorated 75,000", color: "#32CD32", gradient: "linear-gradient(45deg, #32CD32, #90EE90)" },
    "PRORATED - 41,666.66": { label: "Prorated - 41,666.66", color: "#4682B4", gradient: "linear-gradient(45deg, #4682B4, #87CEEB)" },
    "PLAN 1 - 40K": { label: "Plan 1 - 40K", color: "#A9A9A9", gradient: "linear-gradient(45deg, #A9A9A9, #C0C0C0)" },
    "PLAN 2 - 40K": { label: "Plan 2 - 40K", color: "#708090", gradient: "linear-gradient(45deg, #708090, #B0C4DE)" },
    "PLAN 2 - 200K": { label: "Plan 2 - 200K", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "PLAN 70K": { label: "Plan 70K", color: "#1E90FF", gradient: "linear-gradient(45deg, #1E90FF, #87CEEB)" },
    "PRORATED -   41,666": { label: "Prorated - 41,666", color: "#483D8B", gradient: "linear-gradient(45deg, #483D8B, #B0C4DE)" },
    "PLAN 3 - 80": { label: "Plan 3 - 80", color: "#32CD32", gradient: "linear-gradient(45deg, #32CD32, #90EE90)" },
    "PLAN 4 - 60": { label: "Plan 4 - 60", color: "#228B22", gradient: "linear-gradient(45deg, #228B22, #66CDAA)" },
    "SMALL SUITE 5,000 - 500,000": { label: "Small Suite 5,000 - 500,000", color: "#483D8B", gradient: "linear-gradient(45deg, #483D8B, #B0C4DE)" },
    "SMALL SUITE 5,000 - 300,000": { label: "Small Suite 5,000 - 300,000", color: "#483D8B", gradient: "linear-gradient(45deg, #483D8B, #B0C4DE)" },
    "LARGE PRIVATE -300,000": { label: "Large Private - 300,000", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "LARGE PRIVATE -250,000": { label: "Large Private - 250,000", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "REGULAR PRIVATE -250,000": { label: "Regular Private - 250,000", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "REGULAR PRIVATE -200,000": { label: "Regular Private - 200,000", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "REGULAR PRIVATE -120,000": { label: "Regular Private - 120,000", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "PLAN 130K": { label: "Plan 130K", color: "#4682B4", gradient: "linear-gradient(45deg, #4682B4, #87CEEB)" },
    "PLAN 170K": { label: "Plan 170K", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "PLAN 300K": { label: "Plan 300K", color: "#1E90FF", gradient: "linear-gradient(45deg, #1E90FF, #87CEEB)" },
    "PLAN 90K": { label: "Plan 90K", color: "#708090", gradient: "linear-gradient(45deg, #708090, #B0C4DE)" },
    "PLAN 160K": { label: "Plan 160K", color: "#483D8B", gradient: "linear-gradient(45deg, #483D8B, #B0C4DE)" },
    "PLAN 250K": { label: "Plan 250K", color: "#6A5ACD", gradient: "linear-gradient(45deg, #6A5ACD, #B0C4DE)" },
    "WARD 30K": { label: "Ward 30K", color: "#228B22", gradient: "linear-gradient(45deg, #228B22, #66CDAA)" },
    "SMALL PRIVATE 60K": { label: "Small Private 60K", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "SMALL PRIVATE 100K": { label: "Small Private 100K", color: "#4169E1", gradient: "linear-gradient(45deg, #4169E1, #87CEFA)" },
    "asdasdasd": { label: "Unknown Plan", color: "#808080", gradient: "linear-gradient(45deg, #808080, #A9A9A9)" },
    "INDIVIDUAL  GOLD (3) -  SEMI-PRIVATE": { label: "Individual Gold (3) - Semi-Private", color: "#FFD700", gradient: "linear-gradient(45deg, #FFD700, #FFA500)" },
    "PRORATED - 11,666.00": { label: "Prorated - 11,666.00", color: "#A9A9A9", gradient: "linear-gradient(45deg, #A9A9A9, #C0C0C0)" },
    "R&F -   22,500": { label: "R&F - 22,500", color: "#228B22", gradient: "linear-gradient(45deg, #228B22, #66CDAA)" },
    "R&F - 22,500": { label: "R&F - 22,500", color: "#228B22", gradient: "linear-gradient(45deg, #228B22, #66CDAA)" },
    "PRORATED - 16,666": { label: "Prorated - 16,666", color: "#708090", gradient: "linear-gradient(45deg, #708090, #B0C4DE)" },
    "PRORATED - 83,333": { label: "Prorated - 83,333", color: "#4682B4", gradient: "linear-gradient(45deg, #4682B4, #87CEEB)" },
};

export default planColorMap;
